// Hotel Uma Premium Translations - English, Montenegrin, Albanian, German

export const translations = {
  // ENGLISH (Default)
  en: {
    // Navigation
    nav: {
      rooms: 'Rooms',
      amenities: 'Amenities',
      gallery: 'Gallery',
      virtualTour: '360° Tour',
      location: 'Location',
      reviews: 'Reviews',
      contact: 'Contact',
      bookNow: 'Book Now'
    },
    
    // Hero Section
    hero: {
      tagline: '4-Star Experience in the Heart of Ulcinj',
      description: 'Hotel Uma Premium offers a 4-star experience with a rooftop pool, sun terrace, restaurant, bar, and free WiFi. Guests enjoy paid airport shuttle, lounge, elevator, 24-hour front desk, concierge service, outdoor seating, family rooms, breakfast in room, room service, car rental, and a tourist desk. Located just 1.8km from Velika Plaza (Long Beach) with 3 swimming pools and free parking.',
      exploreRooms: 'Explore Rooms',
      viewGallery: 'View Gallery',
      checkAvailability: 'Check Availability & Prices',
      checkIn: 'Check-in',
      checkOut: 'Check-out',
      guests: 'Guests',
      guest: 'Guest',
      searchAvailability: 'Search Availability',
      searching: 'Searching...',
      roomsAvailable: 'Rooms available for',
      night: 'night',
      nights: 'nights',
      scrollForPrices: 'Scroll down for total prices',
      veryGood: 'Very Good',
      reviews: 'reviews'
    },
    
    // Rooms Section
    rooms: {
      title: 'Our Elegant Rooms',
      subtitle: 'Accommodations',
      description: 'Each room is thoughtfully designed to provide the perfect balance of comfort and luxury, featuring modern amenities and a peaceful atmosphere.',
      yourStay: 'Your Stay',
      seeRealTimePrices: 'See real-time prices in booking',
      checkPriceBook: 'Check Price & Book',
      startingFrom: 'Starting from',
      priceLabel: 'Price',
      perNight: '/night',
      forNights: 'For',
      clickToSeePrice: 'Click to see exact price & availability',
      available: 'Available',
      soldOut: 'Sold Out',
      viewDetails: 'View Details & Photos',
      livePrice: 'Live Price',
      roomInfo: 'Room Information',
      roomRate: 'Room rate',
      numberOfNights: 'Number of nights',
      dates: 'Dates',
      total: 'Total',
      taxesIncluded: 'Taxes and fees included',
      checkPriceBookNow: 'Check Price & Book Now',
      photos: 'photos',
      onlyRoomsLeft: 'Only {n} left at this price',
      viewingNow: '{n} people viewing right now',
      bookedToday: 'Booked {n}x today',
      directPrice: 'Direct',
      savePercent: 'SAVE {n}%',
      saveAmount: 'You save {n} per night'
    },
    
    // Room Types
    roomTypes: {
      economyDouble: 'Budget Double Room with Balcony',
      economyDoubleDesc: 'Compact 15m² room with balcony, perfect for budget travelers. Features comfortable double bed, flat-screen TV, free WiFi, air conditioning, and premium toiletries. Private bathroom with shower.',
      standardDouble: 'Double Room with Balcony',
      standardDoubleDesc: 'Comfortable 17m² room with balcony and modern amenities. Features air conditioning, mini-bar fridge, writing desk, soundproof windows, and private bathroom with shower and hairdryer.',
      superiorDouble: 'Comfort Double Room with Balcony',
      superiorDoubleDesc: 'Spacious 20m² room with premium furnishings. Features comfortable double bed, balcony with views, seating area, refrigerator, work desk, mini-bar, and tiled flooring.',
      tripleBalcony: 'Triple Room with Balcony',
      tripleBalconyDesc: 'Perfect for families or groups, this room comfortably accommodates 3 adults. Features private balcony, air conditioning, and all modern amenities.',
      oneBedApartment: 'Family Apartment with Balcony',
      oneBedApartmentDesc: 'Spacious apartment ideal for families or extended stays. Features separate bedroom, living area with sofa, fully equipped kitchenette, and private balcony. Accommodates up to 4 guests.',
      royalApartment: 'Premium Apartment',
      royalApartmentDesc: 'Our most luxurious accommodation with spacious living areas, premium furnishings, full kitchen, and city views. Perfect for families or those seeking extra comfort. Accommodates up to 5 guests.'
    },
    
    // Amenities
    amenityNames: {
      airConditioning: 'Air Conditioning',
      freeWifi: 'Free WiFi',
      flatScreenTv: 'Flat-screen TV',
      privateBathroom: 'Private Bathroom',
      premiumToiletries: 'Premium Toiletries',
      minibar: 'Mini-bar',
      writingDesk: 'Writing Desk',
      soundproofWindows: 'Soundproof Windows',
      balcony: 'Balcony',
      cityView: 'City View',
      seatingArea: 'Seating Area',
      familyFriendly: 'Family Friendly',
      separateBedroom: 'Separate Bedroom',
      kitchenette: 'Kitchenette',
      fullKitchen: 'Full Kitchen',
      livingRoom: 'Living Room',
      premiumFurnishings: 'Premium Furnishings'
    },
    
    // Amenities Section
    amenities: {
      title: 'World-Class Amenities',
      subtitle: 'Luxury Awaits',
      description: 'Enjoy our exceptional facilities designed to make your stay unforgettable.',
      rooftopPool: 'Rooftop Pool',
      rooftopPoolDesc: 'Stunning rooftop pool with panoramic views of Ulcinj',
      restaurantBar: 'Restaurant & Bar',
      restaurantBarDesc: 'On-site restaurant with halal buffet breakfast and refreshing drinks',
      freeParking: 'Free Private Parking',
      freeParkingDesc: 'Secure free parking available for all guests',
      sunTerrace: 'Sun Terrace & Lounge',
      sunTerraceDesc: 'Shared lounge and sun terrace perfect for relaxation',
      airportShuttle: 'Airport Shuttle',
      airportShuttleDesc: 'Paid airport shuttle service available on request',
      frontDesk: '24-Hour Front Desk',
      frontDeskDesc: 'Round-the-clock front desk, concierge, and room service',
      experienceLuxury: 'Experience Mediterranean Luxury',
      experienceLuxuryDesc: 'Let us create the perfect stay with our personalized concierge services.',
      contactConcierge: 'Contact Concierge'
    },
    
    // Gallery
    gallery: {
      title: 'Gallery',
      subtitle: 'Visual Journey',
      description: 'Explore the beauty of Hotel Uma Premium and discover the charm of Ulcinj.',
      all: 'All',
      pool: 'Pool',
      terrace: 'Terrace',
      exterior: 'Exterior',
      rooms: 'Rooms',
      apartment: 'Apartment',
      dining: 'Dining',
      bathroom: 'Bathroom',
      loadMore: 'Load More',
      showAll: 'Show All',
      showing: 'Showing',
      of: 'of',
      images: 'images'
    },
    
    // Location
    location: {
      title: 'Prime Location',
      subtitle: 'Discover',
      description: 'Located in the heart of Ulcinj, Montenegro\'s southernmost coastal gem.',
      nearbyAttractions: 'Nearby Attractions',
      gettingHere: 'Getting Here',
      podgoricaAirport: 'Podgorica Airport: 1.5 hour drive',
      tiranaAirport: 'Tirana Airport (Albania): 2 hour drive',
      dubrovnikAirport: 'Dubrovnik Airport (Croatia): 2.5 hour drive',
      minFromAirport: 'min from Podgorica airport',
      getDirections: 'Get Directions',
      openInMaps: 'Open in Google Maps',
      loadingMap: 'Loading map...',
      address: 'Our Address',
      airportShuttleAvailable: 'Airport shuttle service available on request'
    },
    
    // Attractions
    attractions: {
      velikaPlaza: 'Velika Plaza (Long Beach)',
      velikaPlazaDesc: '13km sandy beach - one of the longest on the Adriatic Sea. Top-rated beach nearby (rating 8.9)',
      oldTown: 'Ulcinj Old Town',
      oldTownDesc: 'Historic fortress with stunning views and charming cobblestone streets',
      malaPlaza: 'Mala Plaza (Small Beach)',
      malaPlazaDesc: 'Popular city beach with crystal clear waters and beach bars',
      adaBojana: 'Ada Bojana',
      adaBojanaDesc: 'River island paradise famous for kitesurfing and untouched nature'
    },
    
    // Testimonials
    testimonials: {
      title: 'Guest Experiences',
      subtitle: 'Testimonials',
      description: 'Hear what our guests have to say about their stay at Hotel Uma Premium.',
      bookingRating: 'Guest Rating',
      reviews: 'Reviews',
      hotelRating: 'Hotel Rating'
    },
    
    // Contact
    contact: {
      title: 'Get In Touch',
      subtitle: 'Contact Us',
      description: 'Have questions? We\'re here to help. Reach out to us anytime.',
      contactInfo: 'Contact Information',
      address: 'Address',
      phone: 'Phone',
      email: 'Email',
      receptionHours: 'Reception Hours',
      alwaysHere: '24/7 - We\'re always here for you',
      followUs: 'Follow Us',
      whatsapp: 'Chat on WhatsApp',
      sendEmail: 'Send Email'
    },
    departments: {
      subtitle: 'Departments',
      title: 'Sales · Careers · Press',
      write: 'Write to us',
      send: 'Send message',
      thanks: 'Thank you — your message has been sent.',
      name: 'Full name',
      email: 'E-mail',
      phone: 'Phone (optional)',
      company: 'Company / agency',
      outlet: 'Media outlet',
      position: 'Position you are applying for',
      cvUrl: 'Link to your CV or LinkedIn (https://…)',
      cvAttach: 'Attach CV (PDF, DOC, DOCX)',
      cvUploading: 'Uploading…',
      cvHint: 'max. 5 MB — or paste a link below',
      cvTooBig: 'The file is larger than 5 MB.',
      pressKit: 'Press kit (ZIP)',
      factSheet: 'Fact sheet (PDF)',
      subject: 'Subject',
      privacy: 'We only use your details to answer this message.',
      error: 'Something went wrong — please try again or e-mail us directly.',
      sales: {
        title: 'Sales & groups',
        short: 'Sales',
        description: 'Group stays, tour operators, travel agencies, corporate rates and events.',
        placeholder: 'Tell us about your group, dates, number of rooms and any special requirements…',
        reply: 'Our sales team replies within one working day.',
      },
      jobs: {
        title: 'Careers',
        short: 'Jobs',
        description: 'Join our team — reception, housekeeping, kitchen, restaurant and management roles.',
        placeholder: 'Tell us about yourself, your experience and when you could start…',
        reply: 'We review every application and will get back to you.',
      },
      pr: {
        title: 'Press & PR',
        short: 'Press',
        description: 'Media enquiries, press visits, interviews, photo & film shoots, partnerships.',
        placeholder: 'Tell us about your outlet, the story and your deadline…',
        reply: 'Our PR contact will be in touch shortly.',
      },
    },
    
    // Footer
    footer: {
      description: 'Experience the perfect blend of Mediterranean charm and modern luxury in beautiful Ulcinj, Montenegro.',
      quickLinks: 'Quick Links',
      legal: 'Legal',
      contactUs: 'Contact Us',
      roomsSuites: 'Rooms & Suites',
      privacyPolicy: 'Privacy Policy',
      termsConditions: 'Terms & Conditions',
      cookiePolicy: 'Cookie Policy',
      cancellationPolicy: 'Cancellation Policy',
      allRights: 'All rights reserved.',
      backToTop: 'Back to Top',
      starHotel: '4-Star Hotel'
    },
    
    // Booking Modal
    booking: {
      secureBooking: 'Secure Online Booking',
      selectDates: 'Select Your Dates',
      realTimeAvailability: 'Real-Time Availability & Pricing',
      realTimeDesc: 'See live prices and available rooms instantly',
      whatsIncluded: "What's Included",
      freeWifi: 'Free High-Speed WiFi',
      breakfastOptions: 'Breakfast Options Available',
      freeCancellation: 'Free Cancellation',
      bestPrice: 'Best Price Guarantee',
      checkAvailabilityPrices: 'Check Availability & Prices',
      loading: 'Loading...',
      changeDates: 'Change Dates',
      secureByBeds24: 'Secure booking powered by Beds24',
      pricesIncludeTaxes: 'All prices include taxes',
      yourStay: 'Your Stay',
      night: 'night',
      nights: 'nights',
      startingFrom: 'Starting from',
      priceLabel: 'Price',
      securePayment: 'Secure Payment',
      instantConfirmation: 'Instant Confirmation',
      loadingRooms: 'Loading available rooms...',
      pleaseWait: 'Please wait a moment'
    },
    
    // Flash Deal
    flashDeal: {
      extraDiscount: 'Extra 5% OFF — Book in the next'
    },

    // Social Media
    social: {
      title: 'Follow Our Journey',
      subtitle: 'Connect With Us',
      description: 'Stay updated with the latest from Hotel Uma Premium. Follow us for exclusive offers, behind-the-scenes moments, and travel inspiration.',
      instagramDesc: 'Beautiful photos from our hotel, rooms, pool, and the charming city of Ulcinj.',
      facebookDesc: 'Updates, guest reviews, special offers and community engagement.',
      tiktokDesc: 'Fun videos, virtual tours, and glimpses of life at Hotel Uma Premium.',
      followInstagram: 'Follow on Instagram',
      followFacebook: 'Like on Facebook',
      followTiktok: 'Follow on TikTok',
      shareExperience: 'Share your experience with us using:',
      viewInstagramProfile: 'View Full Profile on Instagram'
    },
    
    // Virtual Tour
    virtualTour: {
      title: '360° Virtual Tour',
      subtitle: 'Immersive Experience',
      description: 'Explore every corner of Hotel Uma Premium from the comfort of your home. Navigate through our beautiful spaces with interactive 360° views.',
      exterior: 'Hotel Exterior',
      exteriorDesc: 'Explore our beautiful hotel building and entrance',
      pool: 'Rooftop Pool',
      poolDesc: 'Experience our stunning rooftop swimming pool with panoramic views',
      restaurant: 'Restaurant',
      restaurantDesc: 'Discover our elegant dining area serving delicious cuisine',
      reception: 'Reception & Lobby',
      receptionDesc: 'Welcome to our modern reception and comfortable lobby area',
      rooms: 'Guest Rooms',
      roomsDesc: 'Tour our comfortable and well-appointed guest rooms',
      apartments: 'Apartments',
      apartmentsDesc: 'Explore our spacious apartments with full amenities',
      loading: 'Loading 360° view...',
      dragToExplore: 'Drag to explore • Scroll to zoom',
      openFullTour: 'Open Full 360° Tour in Google Maps'
    },
    
    // Special Offer
    specialOffer: {
      title: 'Special Offer',
      discount: '10% OFF',
      description: 'Book direct and save! Get 10% off all rooms when you book through our website.',
      bookDirect: 'Book Direct',
      limitedTime: 'Limited Time Offer'
    },
    
    // Best Price Guarantee
    bestPrice: {
      badge: 'Best Price Guarantee',
      title: 'Best Price Guarantee',
      description: 'Book direct with us and get the best available rate. If you find a lower price elsewhere, we\'ll match it!'
    },
    
    // Why Book Direct
    whyBookDirect: {
      exclusive: 'Exclusive Benefits',
      title: 'Why Book Direct?',
      subtitle: 'Enjoy exclusive perks when you book directly on our website',
      bestPrice: 'Best Price Guarantee',
      bestPriceDesc: 'We guarantee the lowest rate. Find it cheaper elsewhere? We\'ll match it!',
      discount: '10% Discount',
      discountDesc: 'Save 10% instantly on all room types when booking through our website.',
      freeCancellation: 'Flexible Cancellation',
      freeCancellationDesc: 'Plans change. Enjoy free cancellation on most bookings up to 24h before arrival.',
      directSupport: '24/7 Direct Support',
      directSupportDesc: 'Questions? Our team is available around the clock to assist you directly.',
      bookNow: 'Book Direct & Save'
    }
  },

  // MONTENEGRIN (Crnogorski)
  me: {
    // Navigation
    nav: {
      rooms: 'Sobe',
      amenities: 'Sadržaji',
      gallery: 'Galerija',
      virtualTour: '360° Tura',
      location: 'Lokacija',
      reviews: 'Recenzije',
      contact: 'Kontakt',
      bookNow: 'Rezerviši'
    },
    
    // Hero Section
    hero: {
      tagline: '4-zvjezdično iskustvo u srcu Ulcinja',
      description: 'Hotel Uma Premium nudi 4-zvjezdično iskustvo sa bazenom na krovu, sunčanom terasom, restoranom, barom i besplatnim WiFi-jem. Gosti uživaju u plaćenom aerodromskom transferu, salonu, liftu, 24-časovnoj recepciji, concierge usluzi, vanjskom sjedenju, porodičnim sobama, doručku u sobi, sobnoj usluzi, iznajmljivanju automobila i turističkom pultu.',
      exploreRooms: 'Istraži sobe',
      viewGallery: 'Pogledaj galeriju',
      checkAvailability: 'Provjeri dostupnost i cijene',
      checkIn: 'Prijava',
      checkOut: 'Odjava',
      guests: 'Gosti',
      guest: 'Gost',
      searchAvailability: 'Pretraži dostupnost',
      searching: 'Pretražujem...',
      roomsAvailable: 'Sobe dostupne za',
      night: 'noć',
      nights: 'noći',
      scrollForPrices: 'Skrolujte dolje za ukupne cijene',
      veryGood: 'Vrlo dobro',
      reviews: 'recenzija'
    },
    
    // Rooms Section
    rooms: {
      title: 'Naše elegantne sobe',
      subtitle: 'Smještaj',
      description: 'Svaka soba je pažljivo dizajnirana kako bi pružila savršenu ravnotežu udobnosti i luksuza, sa modernim sadržajima i mirnom atmosferom.',
      yourStay: 'Vaš boravak',
      seeRealTimePrices: 'Pogledajte cijene u realnom vremenu u rezervaciji',
      checkPriceBook: 'Provjeri cijenu i rezerviši',
      startingFrom: 'Od',
      priceLabel: 'Cijena',
      perNight: '/noć',
      forNights: 'Za',
      clickToSeePrice: 'Kliknite da vidite tačnu cijenu i dostupnost',
      available: 'Dostupno',
      soldOut: 'Rasprodato',
      viewDetails: 'Pogledaj detalje i slike',
      livePrice: 'Cijena uživo',
      roomInfo: 'Informacije o sobi',
      roomRate: 'Cijena sobe',
      numberOfNights: 'Broj noći',
      dates: 'Datumi',
      total: 'Ukupno',
      taxesIncluded: 'Porezi i takse uključeni',
      checkPriceBookNow: 'Provjeri cijenu i rezerviši odmah',
      photos: 'slike',
      onlyRoomsLeft: 'Samo {n} preostalo po ovoj cijeni',
      viewingNow: '{n} osoba trenutno gleda',
      bookedToday: 'Rezervisano {n}x danas',
      directPrice: 'Direktno',
      savePercent: 'UŠTEDI {n}%',
      saveAmount: 'Uštedite {n} po noći '
    },
    
    // Room Types
    roomTypes: {
      economyDouble: 'Budget dvokrevetna soba sa balkonom',
      economyDoubleDesc: 'Kompaktna soba od 15 m² sa balkonom, idealna za putnike koji paze na budžet. Udoban bračni krevet, TV ravnog ekrana, besplatan WiFi, klima-uređaj i kvalitetna kozmetika. Privatno kupatilo sa tuš-kabinom.',
      standardDouble: 'Dvokrevetna soba sa balkonom',
      standardDoubleDesc: 'Udobna soba od 17 m² sa balkonom i modernom opremom: klima-uređaj, mini-bar frižider, radni sto, zvučno izolovani prozori i privatno kupatilo sa tušem i fenom.',
      superiorDouble: 'Komfor dvokrevetna soba sa balkonom',
      superiorDoubleDesc: 'Prostrana soba od 20 m² sa premium namještajem: udoban bračni krevet, balkon sa pogledom, dio za sjedenje, frižider, radni sto, mini-bar i popločani podovi.',
      tripleBalcony: 'Trokrevetna soba sa balkonom',
      tripleBalconyDesc: 'Idealna za porodice ili prijatelje — udobno prima 3 odrasle osobe. Privatni balkon, klima-uređaj i sva moderna oprema.',
      oneBedApartment: 'Porodični apartman sa balkonom',
      oneBedApartmentDesc: 'Prostran apartman od 45 m² za porodice i duže boravke: odvojena spavaća soba, dnevni boravak sa sofom, potpuno opremljena čajna kuhinja i privatni balkon. Do 4 gosta.',
      royalApartment: 'Premium apartman',
      royalApartmentDesc: 'Naš najluksuzniji smještaj od 60 m²: prostran dnevni boravak, premium namještaj, kompletna kuhinja i pogled na grad. Idealan za porodice i goste koji žele više komfora. Do 5 gostiju.'
    },
    
    // Amenities
    amenityNames: {
      airConditioning: 'Klimatizacija',
      freeWifi: 'Besplatan WiFi',
      flatScreenTv: 'TV sa ravnim ekranom',
      privateBathroom: 'Privatno kupatilo',
      premiumToiletries: 'Vrhunske toaletne potrepštine',
      minibar: 'Mini-bar',
      writingDesk: 'Radni sto',
      soundproofWindows: 'Zvučno izolovani prozori',
      balcony: 'Balkon',
      cityView: 'Pogled na grad',
      seatingArea: 'Prostor za sjedenje',
      familyFriendly: 'Pogodno za porodice',
      separateBedroom: 'Odvojena spavaća soba',
      kitchenette: 'Čajna kuhinja',
      fullKitchen: 'Puna kuhinja',
      livingRoom: 'Dnevna soba',
      premiumFurnishings: 'Vrhunski namještaj'
    },
    
    // Amenities Section
    amenities: {
      title: 'Sadržaji svjetske klase',
      subtitle: 'Luksuz vas čeka',
      description: 'Uživajte u našim izuzetnim sadržajima dizajniranim da vaš boravak učine nezaboravnim.',
      rooftopPool: 'Bazen na krovu',
      rooftopPoolDesc: 'Predivan bazen na krovu sa panoramskim pogledom na Ulcinj',
      restaurantBar: 'Restoran i bar',
      restaurantBarDesc: 'Restoran u sklopu hotela sa halal bufet doručkom i osvježavajućim pićima',
      freeParking: 'Besplatan privatni parking',
      freeParkingDesc: 'Besplatan siguran parking dostupan svim gostima',
      sunTerrace: 'Sunčana terasa i salon',
      sunTerraceDesc: 'Zajednički salon i sunčana terasa savršeni za opuštanje',
      airportShuttle: 'Aerodromski transfer',
      airportShuttleDesc: 'Plaćeni aerodromski transfer dostupan na zahtjev',
      frontDesk: '24-časovna recepcija',
      frontDeskDesc: 'Cjelodnevna recepcija, concierge i sobna usluga',
      experienceLuxury: 'Doživite mediteranski luksuz',
      experienceLuxuryDesc: 'Dozvolite nam da kreiramo savršen boravak uz naše personalizovane concierge usluge.',
      contactConcierge: 'Kontaktirajte concierge'
    },
    
    // Gallery
    gallery: {
      title: 'Galerija',
      subtitle: 'Vizuelno putovanje',
      description: 'Istražite ljepotu Hotela Uma Premium i otkrijte čari Ulcinja.',
      all: 'Sve',
      pool: 'Bazen',
      terrace: 'Terasa',
      exterior: 'Vanjski izgled',
      rooms: 'Sobe',
      apartment: 'Apartman',
      dining: 'Restoran',
      bathroom: 'Kupatilo',
      loadMore: 'Učitaj više',
      showAll: 'Prikaži sve',
      showing: 'Prikazano',
      of: 'od',
      images: 'slika'
    },
    
    // Location
    location: {
      title: 'Izvrsna lokacija',
      subtitle: 'Otkrijte',
      description: 'Smješteni u srcu Ulcinja, najjužnije obalne bisere Crne Gore.',
      nearbyAttractions: 'Obližnje atrakcije',
      gettingHere: 'Kako doći',
      podgoricaAirport: 'Aerodrom Podgorica: 1.5 sat vožnje',
      tiranaAirport: 'Aerodrom Tirana (Albanija): 2 sata vožnje',
      dubrovnikAirport: 'Aerodrom Dubrovnik (Hrvatska): 2.5 sata vožnje',
      minFromAirport: 'min od aerodroma Podgorica',
      getDirections: 'Dobij uputstva',
      openInMaps: 'Otvori u Google Maps',
      loadingMap: 'Učitavanje mape...',
      address: 'Naša adresa',
      airportShuttleAvailable: 'Aerodromski transfer dostupan na zahtjev'
    },
    
    // Attractions
    attractions: {
      velikaPlaza: 'Velika plaža',
      velikaPlazaDesc: '13km pješčane plaže - jedna od najdužih na Jadranskom moru. Najbolje ocijenjena plaža u blizini (ocjena 8.9)',
      oldTown: 'Stari grad Ulcinj',
      oldTownDesc: 'Istorijska tvrđava sa zadivljujućim pogledom i šarmantnim kaldrmisanim ulicama',
      malaPlaza: 'Mala plaža',
      malaPlazaDesc: 'Popularna gradska plaža sa kristalno čistom vodom i beach barovima',
      adaBojana: 'Ada Bojana',
      adaBojanaDesc: 'Riječno ostrvo raj poznat po kitesurfingu i netaknutoj prirodi'
    },
    
    // Testimonials
    testimonials: {
      title: 'Iskustva gostiju',
      subtitle: 'Svjedočanstva',
      description: 'Čujte šta naši gosti imaju reći o svom boravku u Hotelu Uma Premium.',
      bookingRating: 'Ocjena gostiju',
      reviews: 'Recenzija',
      hotelRating: 'Ocjena hotela'
    },
    
    // Contact
    contact: {
      title: 'Kontaktirajte nas',
      subtitle: 'Kontakt',
      description: 'Imate pitanja? Tu smo da pomognemo. Javite nam se u bilo koje vrijeme.',
      contactInfo: 'Kontakt informacije',
      address: 'Adresa',
      phone: 'Telefon',
      email: 'Email',
      receptionHours: 'Radno vrijeme recepcije',
      alwaysHere: '24/7 - Uvijek smo tu za vas',
      followUs: 'Pratite nas',
      whatsapp: 'Pišite na WhatsApp',
      sendEmail: 'Pošaljite email'
    },
    departments: {
      subtitle: 'Odjeljenja',
      title: 'Prodaja · Karijera · Mediji',
      write: 'Pišite nam',
      send: 'Pošalji poruku',
      thanks: 'Hvala — vaša poruka je poslata.',
      name: 'Ime i prezime',
      email: 'E-mail',
      phone: 'Telefon (opciono)',
      company: 'Firma / agencija',
      outlet: 'Medij',
      position: 'Pozicija za koju se prijavljujete',
      cvUrl: 'Link ka CV-u ili LinkedIn profilu (https://…)',
      cvAttach: 'Priložite CV (PDF, DOC, DOCX)',
      cvUploading: 'Otpremanje…',
      cvHint: 'najviše 5 MB — ili unesite link ispod',
      cvTooBig: 'Fajl je veći od 5 MB.',
      pressKit: 'Press kit (ZIP)',
      factSheet: 'Osnovni podaci (PDF)',
      subject: 'Naslov',
      privacy: 'Vaše podatke koristimo samo za odgovor na ovu poruku.',
      error: 'Došlo je do greške — pokušajte ponovo ili nam pišite direktno.',
      sales: {
        title: 'Prodaja i grupe',
        short: 'Prodaja',
        description: 'Grupni boravci, turoperatori, agencije, korporativne cijene i događaji.',
        placeholder: 'Opišite grupu, datume, broj soba i posebne zahtjeve…',
        reply: 'Naš tim za prodaju odgovara u roku od jednog radnog dana.',
      },
      jobs: {
        title: 'Karijera',
        short: 'Posao',
        description: 'Pridružite se timu — recepcija, domaćinstvo, kuhinja, restoran i menadžment.',
        placeholder: 'Recite nam nešto o sebi, iskustvu i kada biste mogli početi…',
        reply: 'Pregledamo svaku prijavu i javićemo vam se.',
      },
      pr: {
        title: 'Mediji i PR',
        short: 'Mediji',
        description: 'Upiti medija, posjete novinara, intervjui, foto i video snimanja, partnerstva.',
        placeholder: 'Opišite medij, temu i rok…',
        reply: 'Naš PR kontakt će vam se uskoro javiti.',
      },
    },
    
    // Footer
    footer: {
      description: 'Doživite savršenu mješavinu mediteranskog šarma i modernog luksuza na zadivljujućoj jadranskoj obali.',
      quickLinks: 'Brze veze',
      legal: 'Pravne informacije',
      contactUs: 'Kontaktirajte nas',
      roomsSuites: 'Sobe i apartmani',
      privacyPolicy: 'Politika privatnosti',
      termsConditions: 'Uslovi korištenja',
      cookiePolicy: 'Politika kolačića',
      cancellationPolicy: 'Politika otkazivanja',
      allRights: 'Sva prava zadržana.',
      backToTop: 'Nazad na vrh',
      starHotel: '4-zvjezdični hotel'
    },
    
    // Booking Modal
    booking: {
      secureBooking: 'Sigurna online rezervacija',
      selectDates: 'Izaberite datume',
      realTimeAvailability: 'Dostupnost i cijene u realnom vremenu',
      realTimeDesc: 'Naš sistem rezervacija prikazuje dostupnost soba uživo i trenutne cijene direktno iz našeg upravljača kanala.',
      whatsIncluded: 'Šta je uključeno:',
      freeWifi: 'Besplatan WiFi',
      breakfastOptions: 'Opcije doručka dostupne',
      freeCancellation: 'Besplatno otkazivanje na odabrane cijene',
      bestPrice: 'Garancija najbolje cijene',
      checkAvailabilityPrices: 'Provjeri dostupnost i cijene',
      loading: 'Učitavam...',
      changeDates: 'Promijeni datume',
      secureByBeds24: 'Sigurna rezervacija putem Beds24',
      pricesIncludeTaxes: 'Sve cijene uključuju poreze'
    },
    
    // Flash Deal
    flashDeal: {
      extraDiscount: 'Dodatnih 5% POPUSTA — Rezervišite u narednih'
    },

    // Social Media
    social: {
      title: 'Pratite naše putovanje',
      subtitle: 'Povežite se s nama',
      description: 'Budite u toku sa najnovijim vijestima iz Hotela Uma Premium. Pratite nas za ekskluzivne ponude, trenutke iza kulisa i inspiraciju za putovanja.',
      instagramDesc: 'Prekrasne fotografije našeg hotela, soba, bazena i šarmantnog grada Ulcinja.',
      facebookDesc: 'Ažuriranja, recenzije gostiju, posebne ponude i angažman zajednice.',
      tiktokDesc: 'Zabavni video snimci, virtualne ture i uvid u život u Hotelu Uma Premium.',
      followInstagram: 'Pratite na Instagramu',
      followFacebook: 'Lajkujte na Facebooku',
      followTiktok: 'Pratite na TikToku',
      shareExperience: 'Podijelite svoje iskustvo s nama koristeći:',
      viewInstagramProfile: 'Pogledajte profil na Instagramu'
    },
    
    // Virtual Tour
    virtualTour: {
      title: '360° Virtualna tura',
      subtitle: 'Iskustvo potapanja',
      description: 'Istražite svaki kutak Hotela Uma Premium iz udobnosti vašeg doma. Navigirajte kroz naše prekrasne prostore sa interaktivnim 360° pogledima.',
      exterior: 'Vanjski izgled hotela',
      exteriorDesc: 'Istražite našu prekrasnu hotelsku zgradu i ulaz',
      pool: 'Bazen na krovu',
      poolDesc: 'Doživite naš zadivljujući bazen na krovu sa panoramskim pogledom',
      restaurant: 'Restoran',
      restaurantDesc: 'Otkrijte naš elegantan prostor za objedovanje sa ukusnom kuhinjom',
      reception: 'Recepcija i lobi',
      receptionDesc: 'Dobrodošli u našu modernu recepciju i udoban lobi prostor',
      rooms: 'Gostinske sobe',
      roomsDesc: 'Obiđite naše udobne i dobro opremljene gostinske sobe',
      apartments: 'Apartmani',
      apartmentsDesc: 'Istražite naše prostrane apartmane sa punim sadržajima',
      loading: 'Učitavanje 360° pogleda...',
      dragToExplore: 'Povucite za istraživanje • Skrolujte za zum',
      openFullTour: 'Otvorite punu 360° turu u Google Maps'
    },
    
    // Special Offer
    specialOffer: {
      title: 'Posebna ponuda',
      discount: '10% popusta',
      description: 'Rezervišite direktno i uštedite! Dobijte 10% popusta na sve sobe kada rezervišete preko naše web stranice.',
      bookDirect: 'Rezerviši direktno',
      limitedTime: 'Ograničena ponuda'
    },
    
    // Best Price Guarantee
    bestPrice: {
      badge: 'Garancija najbolje cijene',
      title: 'Garancija najbolje cijene',
      description: 'Rezervišite direktno kod nas i dobijte najbolju dostupnu cijenu. Ako pronađete nižu cijenu negdje drugdje, izjednačit ćemo je!'
    },
    
    // Why Book Direct
    whyBookDirect: {
      exclusive: 'Ekskluzivne pogodnosti',
      title: 'Zašto rezervisati direktno?',
      subtitle: 'Uživajte u ekskluzivnim pogodnostima kada rezervišete direktno na našoj web stranici',
      bestPrice: 'Garancija najbolje cijene',
      bestPriceDesc: 'Garantujemo najnižu cijenu. Pronađete jeftinije? Izjednačit ćemo!',
      discount: '10% popusta',
      discountDesc: 'Uštedite 10% odmah na svim tipovima soba pri rezervaciji preko naše web stranice.',
      freeCancellation: 'Fleksibilno otkazivanje',
      freeCancellationDesc: 'Planovi se mijenjaju. Uživajte u besplatnom otkazivanju na većini rezervacija do 24h prije dolaska.',
      directSupport: '24/7 Direktna podrška',
      directSupportDesc: 'Imate pitanja? Naš tim je dostupan non-stop da vam direktno pomogne.',
      bookNow: 'Rezerviši direktno i uštedi'
    }
  },
  
  // ALBANIAN (Shqip)
  sq: {
    // Navigation
    nav: {
      rooms: 'Dhomat',
      amenities: 'Komoditetet',
      gallery: 'Galeria',
      virtualTour: 'Tur 360°',
      location: 'Vendndodhja',
      reviews: 'Komentet',
      contact: 'Kontakti',
      bookNow: 'Rezervo tani'
    },
    
    // Hero Section
    hero: {
      tagline: 'Përvojë 4-yjëshe në zemër të Ulqinit',
      description: 'Hotel Uma Premium ofron një përvojë 4-yjëshe me pishinë në çati, tarracë dielli, restorant, bar dhe WiFi falas. Mysafirët gëzojnë transport aeroporti me pagesë, dhomë pritjeje, ashensor, recepsion 24 orë, shërbim concierge, ndenjëse jashtë, dhoma familjare, mëngjes në dhomë, shërbim dhome, makinë me qira dhe pikë turistike.',
      exploreRooms: 'Eksploro dhomat',
      viewGallery: 'Shiko galerinë',
      checkAvailability: 'Kontrollo disponibilitetin dhe çmimet',
      checkIn: 'Check-in',
      checkOut: 'Check-out',
      guests: 'Mysafirë',
      guest: 'Mysafir',
      searchAvailability: 'Kërko disponibilitetin',
      searching: 'Duke kërkuar...',
      roomsAvailable: 'Dhomat e disponueshme për',
      night: 'natë',
      nights: 'net',
      scrollForPrices: 'Lëviz poshtë për të parë çmimet totale',
      veryGood: 'Shumë mirë',
      reviews: 'komente'
    },
    
    // Rooms Section
    rooms: {
      title: 'Dhomat tona elegante',
      subtitle: 'Akomodimi',
      description: 'Çdo dhomë është projektuar me kujdes për të ofruar balancën perfekte të komoditetit dhe luksit, me pajisje moderne dhe atmosferë të qetë.',
      yourStay: 'Qëndrimi juaj',
      seeRealTimePrices: 'Shikoni çmimet në kohë reale në rezervim',
      checkPriceBook: 'Kontrollo çmimin dhe rezervo',
      startingFrom: 'Nga',
      priceLabel: 'Çmimi',
      perNight: '/natë',
      forNights: 'Për',
      clickToSeePrice: 'Klikoni për të parë çmimin dhe disponibilitetin e saktë',
      available: 'E disponueshme',
      soldOut: 'E shitur',
      viewDetails: 'Shiko detajet dhe fotot',
      livePrice: 'Çmim i drejtpërdrejtë',
      roomInfo: 'Informacion për dhomën',
      roomRate: 'Tarifa e dhomës',
      numberOfNights: 'Numri i netëve',
      dates: 'Datat',
      total: 'Totali',
      taxesIncluded: 'Taksat dhe tarifat e përfshira',
      checkPriceBookNow: 'Kontrollo çmimin dhe rezervo tani',
      photos: 'foto',
      onlyRoomsLeft: 'Vetëm {n} të mbetura me këtë çmim',
      viewingNow: '{n} persona po shikojnë tani',
      bookedToday: 'Rezervuar {n}x sot',
      directPrice: 'Direkt',
      savePercent: 'KURSE {n}%',
      saveAmount: 'Kurseni {n} për natë '
    },
    
    // Room Types
    roomTypes: {
      economyDouble: 'Dhomë dyshe Budget me ballkon',
      economyDoubleDesc: 'Dhomë kompakte 15 m² me ballkon, ideale për udhëtarët me buxhet. Krevat dopio komod, TV me ekran të sheshtë, WiFi falas, kondicioner dhe produkte higjienike premium. Banjë private me dush.',
      standardDouble: 'Dhomë dyshe me ballkon',
      standardDoubleDesc: 'Dhomë komode 17 m² me ballkon dhe pajisje moderne: kondicioner, frigorifer mini-bar, tavolinë pune, dritare me izolim akustik dhe banjë private me dush e tharëse flokësh.',
      superiorDouble: 'Dhomë dyshe Comfort me ballkon',
      superiorDoubleDesc: 'Dhomë e bollshme 20 m² me mobilim premium: krevat dopio komod, ballkon me pamje, kënd ulje, frigorifer, tavolinë pune, mini-bar dhe dysheme me pllaka.',
      tripleBalcony: 'Dhomë treshe me ballkon',
      tripleBalconyDesc: 'Ideale për familje ose grupe — pret komod 3 të rritur. Ballkon privat, kondicioner dhe gjithë pajisjet moderne.',
      oneBedApartment: 'Apartament familjar me ballkon',
      oneBedApartmentDesc: 'Apartament i bollshëm 45 m² për familje dhe qëndrime të gjata: dhomë gjumi e veçantë, dhomë ndenjjeje me divan, kuzhinë e vogël plotësisht e pajisur dhe ballkon privat. Deri në 4 mysafirë.',
      royalApartment: 'Apartament Premium',
      royalApartmentDesc: 'Akomodimi ynë më luksoz, 60 m²: hapësira të bollshme ndenjjeje, mobilim premium, kuzhinë e plotë dhe pamje nga qyteti. Ideal për familje dhe për ata që kërkojnë më shumë komoditet. Deri në 5 mysafirë.'
    },
    
    // Amenities
    amenityNames: {
      airConditioning: 'Klimatizim',
      freeWifi: 'WiFi falas',
      flatScreenTv: 'TV me ekran të sheshtë',
      privateBathroom: 'Banjë private',
      premiumToiletries: 'Produkte tualeti premium',
      minibar: 'Mini-bar',
      writingDesk: 'Tavolinë shkrimi',
      soundproofWindows: 'Dritare të izoluara nga zhurma',
      balcony: 'Ballkon',
      cityView: 'Pamje qyteti',
      seatingArea: 'Zonë ndenjëse',
      familyFriendly: 'Miqësore për familjet',
      separateBedroom: 'Dhomë gjumi e veçantë',
      kitchenette: 'Çaj-kuzhinë',
      fullKitchen: 'Kuzhinë e plotë',
      livingRoom: 'Dhomë jetese',
      premiumFurnishings: 'Mobilim premium'
    },
    
    // Amenities Section
    amenities: {
      title: 'Komoditete të klasit botëror',
      subtitle: 'Luksi ju pret',
      description: 'Shijoni lehtësirat tona të jashtëzakonshme të dizajnuara për ta bërë qëndrimin tuaj të paharrueshëm.',
      rooftopPool: 'Pishinë në çati',
      rooftopPoolDesc: 'Pishinë mahnitëse në çati me pamje panoramike të Ulqinit',
      restaurantBar: 'Restorant dhe bar',
      restaurantBarDesc: 'Restorant në vend me bufé mëngjesi hallall dhe pije freskuese',
      freeParking: 'Parking privat falas',
      freeParkingDesc: 'Parking i sigurt falas i disponueshëm për të gjithë mysafirët',
      sunTerrace: 'Tarracë dielli dhe sallë pritjeje',
      sunTerraceDesc: 'Sallë pritjeje e përbashkët dhe tarracë dielli perfekte për relaksim',
      airportShuttle: 'Transport aeroporti',
      airportShuttleDesc: 'Shërbim transporti aeroporti me pagesë i disponueshëm sipas kërkesës',
      frontDesk: 'Recepsion 24-orësh',
      frontDeskDesc: 'Recepsion gjatë gjithë orarit, concierge dhe shërbim dhome',
      experienceLuxury: 'Përjetoni luksin mesdhetar',
      experienceLuxuryDesc: 'Na lejoni të krijojmë qëndrimin perfekt me shërbimet tona të personalizuara concierge.',
      contactConcierge: 'Kontakto concierge'
    },
    
    // Gallery
    gallery: {
      title: 'Galeria',
      subtitle: 'Udhëtim vizual',
      description: 'Eksploroni bukurinë e Hotel Uma Premium dhe zbuloni sharmin e Ulqinit.',
      all: 'Të gjitha',
      pool: 'Pishinë',
      terrace: 'Tarracë',
      exterior: 'Pamje e jashtme',
      rooms: 'Dhomat',
      apartment: 'Apartamenti',
      dining: 'Restoranti',
      bathroom: 'Banja',
      loadMore: 'Ngarko më shumë',
      showAll: 'Shfaq të gjitha',
      showing: 'Duke shfaqur',
      of: 'nga',
      images: 'foto'
    },
    
    // Location
    location: {
      title: 'Vendndodhje e shkëlqyer',
      subtitle: 'Zbuloni',
      description: 'Të vendosur në zemër të Ulqinit, margaritari bregdetar më jugor i Malit të Zi.',
      nearbyAttractions: 'Atraksionet në afërsi',
      gettingHere: 'Si të arrini',
      podgoricaAirport: 'Aeroporti i Podgoricës: 1.5 orë me makinë',
      tiranaAirport: 'Aeroporti i Tiranës (Shqipëri): 2 orë me makinë',
      dubrovnikAirport: 'Aeroporti i Dubrovnikut (Kroaci): 2.5 orë me makinë',
      minFromAirport: 'min nga aeroporti i Podgoricës',
      getDirections: 'Merr udhëzimet',
      openInMaps: 'Hap në Google Maps',
      loadingMap: 'Duke ngarkuar hartën...',
      address: 'Adresa jonë',
      airportShuttleAvailable: 'Shërbimi i transportit të aeroportit i disponueshëm sipas kërkesës'
    },
    
    // Attractions
    attractions: {
      velikaPlaza: 'Plazhi i Madh',
      velikaPlazaDesc: '13km plazh me rërë - një nga më të gjatët në Detin Adriatik. Plazhi më i vlerësuar në afërsi (vlerësim 8.9)',
      oldTown: 'Qyteti i vjetër i Ulqinit',
      oldTownDesc: 'Fortesë historike me pamje mahnitëse dhe rrugë të bukura me kalldrëm',
      malaPlaza: 'Plazhi i Vogël',
      malaPlazaDesc: 'Plazh popullor qyteti me ujëra kristal të pastër dhe beach bar',
      adaBojana: 'Ada Bojana',
      adaBojanaDesc: 'Ishulli lumor parajsë i famshëm për kitesurfing dhe natyrën e paprekur'
    },
    
    // Testimonials
    testimonials: {
      title: 'Përvojat e mysafirëve',
      subtitle: 'Dëshmitë',
      description: 'Dëgjoni çfarë kanë për të thënë mysafirët tanë për qëndrimin e tyre në Hotel Uma Premium.',
      bookingRating: 'Vlerësimi i mysafirëve',
      reviews: 'Komente',
      hotelRating: 'Vlerësimi i hotelit'
    },
    
    // Contact
    contact: {
      title: 'Na kontaktoni',
      subtitle: 'Kontakti',
      description: 'Keni pyetje? Jemi këtu për t\'ju ndihmuar. Na kontaktoni në çdo kohë.',
      contactInfo: 'Informacioni i kontaktit',
      address: 'Adresa',
      phone: 'Telefoni',
      email: 'Email',
      receptionHours: 'Orari i recepsionit',
      alwaysHere: '24/7 - Jemi gjithmonë këtu për ju',
      followUs: 'Na ndiqni',
      whatsapp: 'Bisedoni në WhatsApp',
      sendEmail: 'Dërgoni email'
    },
    departments: {
      subtitle: 'Departamentet',
      title: 'Shitje · Karrierë · Media',
      write: 'Na shkruani',
      send: 'Dërgo mesazhin',
      thanks: 'Faleminderit — mesazhi juaj u dërgua.',
      name: 'Emri i plotë',
      email: 'E-mail',
      phone: 'Telefon (opsional)',
      company: 'Kompania / agjencia',
      outlet: 'Media',
      position: 'Pozicioni për të cilin aplikoni',
      cvUrl: 'Link për CV ose LinkedIn (https://…)',
      cvAttach: 'Bashkëngjit CV (PDF, DOC, DOCX)',
      cvUploading: 'Duke ngarkuar…',
      cvHint: 'maks. 5 MB — ose vendosni një link më poshtë',
      cvTooBig: 'Skedari është më i madh se 5 MB.',
      pressKit: 'Paketa për media (ZIP)',
      factSheet: 'Fakte kryesore (PDF)',
      subject: 'Subjekti',
      privacy: 'Të dhënat tuaja përdoren vetëm për t\'iu përgjigjur këtij mesazhi.',
      error: 'Ndodhi një gabim — provoni përsëri ose na shkruani direkt.',
      sales: {
        title: 'Shitje dhe grupe',
        short: 'Shitje',
        description: 'Qëndrime në grup, operatorë turistikë, agjenci, çmime korporative dhe evente.',
        placeholder: 'Na tregoni për grupin, datat, numrin e dhomave dhe kërkesat e veçanta…',
        reply: 'Ekipi ynë i shitjeve përgjigjet brenda një dite pune.',
      },
      jobs: {
        title: 'Karrierë',
        short: 'Punë',
        description: 'Bashkohuni me ekipin — recepsion, mirëmbajtje, kuzhinë, restorant dhe menaxhim.',
        placeholder: 'Na tregoni për veten, përvojën dhe kur mund të filloni…',
        reply: 'Shqyrtojmë çdo aplikim dhe do t\'ju kontaktojmë.',
      },
      pr: {
        title: 'Media dhe PR',
        short: 'Media',
        description: 'Kërkesa mediatike, vizita të shtypit, intervista, xhirime foto/video, partneritete.',
        placeholder: 'Na tregoni për median, temën dhe afatin…',
        reply: 'Kontakti ynë i PR do t\'ju përgjigjet së shpejti.',
      },
    },
    
    // Footer
    footer: {
      description: 'Përjetoni përzierjen perfekte të sharmit mesdhetar dhe luksit modern në Ulqin të bukur, Mali i Zi.',
      quickLinks: 'Lidhje të shpejta',
      legal: 'Ligjore',
      contactUs: 'Na kontaktoni',
      roomsSuites: 'Dhoma dhe apartamente',
      privacyPolicy: 'Politika e privatësisë',
      termsConditions: 'Kushtet dhe termat',
      cookiePolicy: 'Politika e cookies',
      cancellationPolicy: 'Politika e anulimit',
      allRights: 'Të gjitha të drejtat e rezervuara.',
      backToTop: 'Kthehu në krye',
      starHotel: 'Hotel 4-yjësh'
    },
    
    // Booking Modal
    booking: {
      secureBooking: 'Rezervim online i sigurt',
      selectDates: 'Zgjidhni datat tuaja',
      realTimeAvailability: 'Disponibiliteti dhe çmimet në kohë reale',
      realTimeDesc: 'Sistemi ynë i rezervimeve tregon disponibilitetin e dhomave në kohë reale dhe çmimet aktuale drejtpërdrejt nga menaxheri ynë i kanaleve.',
      whatsIncluded: 'Çfarë përfshihet:',
      freeWifi: 'WiFi falas',
      breakfastOptions: 'Opsione mëngjesi të disponueshme',
      freeCancellation: 'Anulim falas në tarifat e zgjedhura',
      bestPrice: 'Garanci e çmimit më të mirë',
      checkAvailabilityPrices: 'Kontrollo disponibilitetin dhe çmimet',
      loading: 'Duke ngarkuar...',
      changeDates: 'Ndrysho datat',
      secureByBeds24: 'Rezervim i sigurt nga Beds24',
      pricesIncludeTaxes: 'Të gjitha çmimet përfshijnë taksat'
    },
    
    // Flash Deal
    flashDeal: {
      extraDiscount: '5% EKSTRA ZBRITJE — Rezervoni brenda'
    },

    // Social Media
    social: {
      title: 'Ndiqni udhëtimin tonë',
      subtitle: 'Lidhu me ne',
      description: 'Qëndroni të informuar me të rejat nga Hotel Uma Premium. Na ndiqni për oferta ekskluzive, momente pas skenave dhe frymëzim për udhëtime.',
      instagramDesc: 'Foto të bukura nga hoteli ynë, dhomat, pishina dhe qyteti magjepsës i Ulqinit.',
      facebookDesc: 'Përditësime, komente të mysafirëve, oferta speciale dhe angazhim i komunitetit.',
      tiktokDesc: 'Video argëtuese, ture virtuale dhe pamje të jetës në Hotel Uma Premium.',
      followInstagram: 'Na ndiqni në Instagram',
      followFacebook: 'Na pëlqeni në Facebook',
      followTiktok: 'Na ndiqni në TikTok',
      shareExperience: 'Ndani përvojën tuaj me ne duke përdorur:',
      viewInstagramProfile: 'Shikoni Profilin në Instagram'
    },
    
    // Virtual Tour
    virtualTour: {
      title: 'Tur Virtual 360°',
      subtitle: 'Përvojë zhytëse',
      description: 'Eksploroni çdo cep të Hotel Uma Premium nga komoditeti i shtëpisë suaj. Navigoni nëpër hapësirat tona të bukura me pamje interaktive 360°.',
      exterior: 'Pamja e jashtme e hotelit',
      exteriorDesc: 'Eksploroni ndërtesën tonë të bukur të hotelit dhe hyrjen',
      pool: 'Pishina në çati',
      poolDesc: 'Përjetoni pishinën tonë mahnitëse në çati me pamje panoramike',
      restaurant: 'Restoranti',
      restaurantDesc: 'Zbuloni zonën tonë elegante të ngrënies që shërben kuzhinë të shijshme',
      reception: 'Recepcioni dhe hyrja',
      receptionDesc: 'Mirë se vini në recepsionin tonë modern dhe zonën e rehatshme të hyrjes',
      rooms: 'Dhomat e mysafirëve',
      roomsDesc: 'Vizitoni dhomat tona të rehatshme dhe të pajisura mirë',
      apartments: 'Apartamentet',
      apartmentsDesc: 'Eksploroni apartamentet tona të gjera me të gjitha komoditetet',
      loading: 'Duke ngarkuar pamjen 360°...',
      dragToExplore: 'Tërhiqni për të eksploruar • Lëvizni për të zmadhuar',
      openFullTour: 'Hapni turin e plotë 360° në Google Maps'
    },
    
    // Special Offer
    specialOffer: {
      title: 'Ofertë speciale',
      discount: '10% zbritje',
      description: 'Rezervoni direkt dhe kurseni! Merrni 10% zbritje në të gjitha dhomat kur rezervoni përmes faqes sonë.',
      bookDirect: 'Rezervo direkt',
      limitedTime: 'Ofertë e kufizuar'
    },
    
    // Best Price Guarantee
    bestPrice: {
      badge: 'Garanci e çmimit më të mirë',
      title: 'Garanci e çmimit më të mirë',
      description: 'Rezervoni direkt me ne dhe merrni tarifën më të mirë të disponueshme. Nëse gjeni një çmim më të ulët diku tjetër, ne do ta barazojmë!'
    },
    
    // Why Book Direct
    whyBookDirect: {
      exclusive: 'Përfitime ekskluzive',
      title: 'Pse të rezervoni direkt?',
      subtitle: 'Shijoni përfitime ekskluzive kur rezervoni direkt në faqen tonë',
      bestPrice: 'Garanci e çmimit më të mirë',
      bestPriceDesc: 'Garantojmë çmimin më të ulët. E gjeni më lirë? Do ta barazojmë!',
      discount: '10% zbritje',
      discountDesc: 'Kurseni 10% menjëherë në të gjitha llojet e dhomave kur rezervoni përmes faqes sonë.',
      freeCancellation: 'Anulim fleksibël',
      freeCancellationDesc: 'Planet ndryshojnë. Shijoni anulim falas në shumicën e rezervimeve deri në 24h para mbërritjes.',
      directSupport: 'Mbështetje direkte 24/7',
      directSupportDesc: 'Keni pyetje? Ekipi ynë është i disponueshëm gjatë gjithë kohës për t\'ju ndihmuar direkt.',
      bookNow: 'Rezervo direkt dhe kurse'
    }
  },
  
  // GERMAN (Deutsch)
  de: {
    // Navigation
    nav: {
      rooms: 'Zimmer',
      amenities: 'Ausstattung',
      gallery: 'Galerie',
      virtualTour: '360° Tour',
      location: 'Lage',
      reviews: 'Bewertungen',
      contact: 'Kontakt',
      bookNow: 'Jetzt buchen'
    },
    
    // Hero Section
    hero: {
      tagline: '4-Sterne-Erlebnis im Herzen von Ulcinj',
      description: 'Das Hotel Uma Premium bietet ein 4-Sterne-Erlebnis mit Dachpool, Sonnenterrasse, Restaurant, Bar und kostenlosem WLAN. Gäste genießen kostenpflichtigen Flughafentransfer, Lounge, Aufzug, 24-Stunden-Rezeption, Concierge-Service, Außensitzplätze, Familienzimmer, Frühstück aufs Zimmer, Zimmerservice, Autovermietung und Touristenbüro.',
      exploreRooms: 'Zimmer entdecken',
      viewGallery: 'Galerie ansehen',
      checkAvailability: 'Verfügbarkeit und Preise prüfen',
      checkIn: 'Anreise',
      checkOut: 'Abreise',
      guests: 'Gäste',
      guest: 'Gast',
      searchAvailability: 'Verfügbarkeit suchen',
      searching: 'Suche läuft...',
      roomsAvailable: 'Zimmer verfügbar für',
      night: 'Nacht',
      nights: 'Nächte',
      scrollForPrices: 'Nach unten scrollen für Gesamtpreise',
      veryGood: 'Sehr gut',
      reviews: 'Bewertungen'
    },
    
    // Rooms Section
    rooms: {
      title: 'Unsere eleganten Zimmer',
      subtitle: 'Unterkünfte',
      description: 'Jedes Zimmer ist sorgfältig gestaltet, um die perfekte Balance aus Komfort und Luxus zu bieten, mit modernen Annehmlichkeiten und einer friedlichen Atmosphäre.',
      yourStay: 'Ihr Aufenthalt',
      seeRealTimePrices: 'Echtzeitpreise in der Buchung anzeigen',
      checkPriceBook: 'Preis prüfen und buchen',
      startingFrom: 'Ab',
      priceLabel: 'Preis',
      perNight: '/Nacht',
      forNights: 'Für',
      clickToSeePrice: 'Klicken Sie für genauen Preis und Verfügbarkeit',
      available: 'Verfügbar',
      soldOut: 'Ausgebucht',
      viewDetails: 'Details und Fotos ansehen',
      livePrice: 'Echtzeitpreis',
      roomInfo: 'Zimmerinformation',
      roomRate: 'Zimmerpreis',
      numberOfNights: 'Anzahl Nächte',
      dates: 'Daten',
      total: 'Gesamt',
      taxesIncluded: 'Steuern und Gebühren inbegriffen',
      checkPriceBookNow: 'Preis prüfen und jetzt buchen',
      photos: 'Fotos',
      onlyRoomsLeft: 'Nur noch {n} zu diesem Preis',
      viewingNow: '{n} Personen schauen gerade',
      bookedToday: 'Heute {n}x gebucht',
      directPrice: 'Direkt',
      savePercent: 'SPAREN {n}%',
      saveAmount: 'Sie sparen {n} pro Nacht '
    },
    
    // Room Types
    roomTypes: {
      economyDouble: 'Budget-Doppelzimmer mit Balkon',
      economyDoubleDesc: 'Kompaktes 15-m²-Zimmer mit Balkon – ideal für preisbewusste Reisende. Bequemes Doppelbett, Flachbild-TV, kostenloses WLAN, Klimaanlage und hochwertige Pflegeprodukte. Eigenes Bad mit Dusche.',
      standardDouble: 'Doppelzimmer mit Balkon',
      standardDoubleDesc: 'Komfortables 17-m²-Zimmer mit Balkon und moderner Ausstattung: Klimaanlage, Minibar-Kühlschrank, Schreibtisch, schallisolierte Fenster und eigenes Bad mit Dusche und Haartrockner.',
      superiorDouble: 'Komfort-Doppelzimmer mit Balkon',
      superiorDoubleDesc: 'Geräumiges 20-m²-Zimmer mit hochwertiger Einrichtung: bequemes Doppelbett, Balkon mit Aussicht, Sitzecke, Kühlschrank, Arbeitsplatz, Minibar und Fliesenboden.',
      tripleBalcony: 'Dreibettzimmer mit Balkon',
      tripleBalconyDesc: 'Ideal für Familien oder Freunde – bietet bequem Platz für 3 Erwachsene. Eigener Balkon, Klimaanlage und moderne Ausstattung.',
      oneBedApartment: 'Familienapartment mit Balkon',
      oneBedApartmentDesc: 'Geräumiges 45-m²-Apartment für Familien und längere Aufenthalte: separates Schlafzimmer, Wohnbereich mit Sofa, voll ausgestattete Kitchenette und eigener Balkon. Für bis zu 4 Gäste.',
      royalApartment: 'Premium-Apartment',
      royalApartmentDesc: 'Unsere luxuriöseste Unterkunft mit 60 m²: großzügiger Wohnbereich, edle Möbel, voll ausgestattete Küche und Stadtblick. Perfekt für Familien und alle, die mehr Komfort wünschen. Für bis zu 5 Gäste.'
    },
    
    // Amenities
    amenityNames: {
      airConditioning: 'Klimaanlage',
      freeWifi: 'Kostenloses WLAN',
      flatScreenTv: 'Flachbild-TV',
      privateBathroom: 'Eigenes Bad',
      premiumToiletries: 'Hochwertige Pflegeprodukte',
      minibar: 'Minibar',
      writingDesk: 'Schreibtisch',
      soundproofWindows: 'Schalldichte Fenster',
      balcony: 'Balkon',
      cityView: 'Stadtblick',
      seatingArea: 'Sitzbereich',
      familyFriendly: 'Familienfreundlich',
      separateBedroom: 'Separates Schlafzimmer',
      kitchenette: 'Küchenzeile',
      fullKitchen: 'Vollständige Küche',
      livingRoom: 'Wohnzimmer',
      premiumFurnishings: 'Premium-Einrichtung'
    },
    
    // Amenities Section
    amenities: {
      title: 'Erstklassige Ausstattung',
      subtitle: 'Luxus erwartet Sie',
      description: 'Genießen Sie unsere außergewöhnlichen Einrichtungen, die Ihren Aufenthalt unvergesslich machen.',
      rooftopPool: 'Dachpool',
      rooftopPoolDesc: 'Atemberaubender Dachpool mit Panoramablick auf Ulcinj',
      restaurantBar: 'Restaurant und Bar',
      restaurantBarDesc: 'Hauseigenes Restaurant mit Halal-Frühstücksbüffet und erfrischenden Getränken',
      freeParking: 'Kostenloser Privatparkplatz',
      freeParkingDesc: 'Kostenloser sicherer Parkplatz für alle Gäste verfügbar',
      sunTerrace: 'Sonnenterrasse und Lounge',
      sunTerraceDesc: 'Gemeinschaftslounge und Sonnenterrasse perfekt zum Entspannen',
      airportShuttle: 'Flughafentransfer',
      airportShuttleDesc: 'Kostenpflichtiger Flughafentransfer auf Anfrage verfügbar',
      frontDesk: '24-Stunden-Rezeption',
      frontDeskDesc: 'Rund um die Uhr Rezeption, Concierge und Zimmerservice',
      experienceLuxury: 'Erleben Sie mediterranen Luxus',
      experienceLuxuryDesc: 'Lassen Sie uns mit unseren personalisierten Concierge-Services den perfekten Aufenthalt gestalten.',
      contactConcierge: 'Concierge kontaktieren'
    },
    
    // Gallery
    gallery: {
      title: 'Galerie',
      subtitle: 'Visuelle Reise',
      description: 'Entdecken Sie die Schönheit des Hotel Uma Premium und den Charme von Ulcinj.',
      all: 'Alle',
      pool: 'Pool',
      terrace: 'Terrasse',
      exterior: 'Außenansicht',
      rooms: 'Zimmer',
      apartment: 'Apartment',
      dining: 'Restaurant',
      bathroom: 'Badezimmer',
      loadMore: 'Mehr laden',
      showAll: 'Alle anzeigen',
      showing: 'Zeige',
      of: 'von',
      images: 'Bilder'
    },
    
    // Location
    location: {
      title: 'Erstklassige Lage',
      subtitle: 'Entdecken',
      description: 'Gelegen im Herzen von Ulcinj, Montenegros südlichstem Küstenjuwel.',
      nearbyAttractions: 'Attraktionen in der Nähe',
      gettingHere: 'Anreise',
      podgoricaAirport: 'Flughafen Podgorica: 1,5 Stunden Fahrt',
      tiranaAirport: 'Flughafen Tirana (Albanien): 2 Stunden Fahrt',
      dubrovnikAirport: 'Flughafen Dubrovnik (Kroatien): 2,5 Stunden Fahrt',
      minFromAirport: 'Min vom Flughafen Podgorica',
      getDirections: 'Wegbeschreibung',
      openInMaps: 'In Google Maps öffnen',
      loadingMap: 'Karte wird geladen...',
      address: 'Unsere Adresse',
      airportShuttleAvailable: 'Flughafentransfer auf Anfrage verfügbar'
    },
    
    // Attractions
    attractions: {
      velikaPlaza: 'Velika Plaza (Großer Strand)',
      velikaPlazaDesc: '13km Sandstrand - einer der längsten an der Adria. Bestbewerteter Strand in der Nähe (Bewertung 8,9)',
      oldTown: 'Altstadt von Ulcinj',
      oldTownDesc: 'Historische Festung mit atemberaubender Aussicht und charmanten Kopfsteinpflasterstraßen',
      malaPlaza: 'Mala Plaza (Kleiner Strand)',
      malaPlazaDesc: 'Beliebter Stadtstrand mit kristallklarem Wasser und Strandbars',
      adaBojana: 'Ada Bojana',
      adaBojanaDesc: 'Flussinsel-Paradies berühmt für Kitesurfen und unberührte Natur'
    },
    
    // Testimonials
    testimonials: {
      title: 'Gästeerfahrungen',
      subtitle: 'Bewertungen',
      description: 'Hören Sie, was unsere Gäste über ihren Aufenthalt im Hotel Uma Premium sagen.',
      bookingRating: 'Gästebewertung',
      reviews: 'Bewertungen',
      hotelRating: 'Hotelbewertung'
    },
    
    // Contact
    contact: {
      title: 'Kontakt aufnehmen',
      subtitle: 'Kontakt',
      description: 'Haben Sie Fragen? Wir sind hier um zu helfen. Kontaktieren Sie uns jederzeit.',
      contactInfo: 'Kontaktinformationen',
      address: 'Adresse',
      phone: 'Telefon',
      email: 'E-Mail',
      receptionHours: 'Rezeptionszeiten',
      alwaysHere: '24/7 - Wir sind immer für Sie da',
      followUs: 'Folgen Sie uns',
      whatsapp: 'Chat auf WhatsApp',
      sendEmail: 'E-Mail senden'
    },
    departments: {
      subtitle: 'Abteilungen',
      title: 'Vertrieb · Karriere · Presse',
      write: 'Schreiben Sie uns',
      send: 'Nachricht senden',
      thanks: 'Vielen Dank — Ihre Nachricht wurde gesendet.',
      name: 'Vollständiger Name',
      email: 'E-Mail',
      phone: 'Telefon (optional)',
      company: 'Firma / Agentur',
      outlet: 'Medium',
      position: 'Stelle, auf die Sie sich bewerben',
      cvUrl: 'Link zu Lebenslauf oder LinkedIn (https://…)',
      cvAttach: 'Lebenslauf anhängen (PDF, DOC, DOCX)',
      cvUploading: 'Wird hochgeladen…',
      cvHint: 'max. 5 MB — oder unten einen Link einfügen',
      cvTooBig: 'Die Datei ist größer als 5 MB.',
      pressKit: 'Pressemappe (ZIP)',
      factSheet: 'Factsheet (PDF)',
      subject: 'Betreff',
      privacy: 'Ihre Daten verwenden wir nur zur Beantwortung dieser Nachricht.',
      error: 'Etwas ist schiefgelaufen — bitte erneut versuchen oder direkt mailen.',
      sales: {
        title: 'Vertrieb & Gruppen',
        short: 'Vertrieb',
        description: 'Gruppenreisen, Reiseveranstalter, Agenturen, Firmenraten und Veranstaltungen.',
        placeholder: 'Erzählen Sie uns von Ihrer Gruppe, Termine, Zimmeranzahl und Sonderwünsche…',
        reply: 'Unser Vertriebsteam antwortet innerhalb eines Werktags.',
      },
      jobs: {
        title: 'Karriere',
        short: 'Jobs',
        description: 'Werden Sie Teil des Teams — Rezeption, Housekeeping, Küche, Restaurant und Management.',
        placeholder: 'Erzählen Sie uns von sich, Ihrer Erfahrung und wann Sie beginnen könnten…',
        reply: 'Wir prüfen jede Bewerbung und melden uns bei Ihnen.',
      },
      pr: {
        title: 'Presse & PR',
        short: 'Presse',
        description: 'Medienanfragen, Pressereisen, Interviews, Foto- & Filmaufnahmen, Partnerschaften.',
        placeholder: 'Erzählen Sie uns von Ihrem Medium, der Geschichte und Ihrer Deadline…',
        reply: 'Unser PR-Kontakt meldet sich in Kürze.',
      },
    },
    
    // Footer
    footer: {
      description: 'Erleben Sie die perfekte Mischung aus mediterranem Charme und modernem Luxus im wunderschönen Ulcinj, Montenegro.',
      quickLinks: 'Schnelllinks',
      legal: 'Rechtliches',
      contactUs: 'Kontaktieren Sie uns',
      roomsSuites: 'Zimmer und Suiten',
      privacyPolicy: 'Datenschutzrichtlinie',
      termsConditions: 'Allgemeine Geschäftsbedingungen',
      cookiePolicy: 'Cookie-Richtlinie',
      cancellationPolicy: 'Stornierungsbedingungen',
      allRights: 'Alle Rechte vorbehalten.',
      backToTop: 'Nach oben',
      starHotel: '4-Sterne-Hotel'
    },
    
    // Booking Modal
    booking: {
      secureBooking: 'Sichere Online-Buchung',
      selectDates: 'Wählen Sie Ihre Daten',
      realTimeAvailability: 'Echtzeit-Verfügbarkeit und Preise',
      realTimeDesc: 'Unser Buchungssystem zeigt Live-Zimmerverfügbarkeit und aktuelle Preise direkt von unserem Channel Manager.',
      whatsIncluded: 'Was inbegriffen ist:',
      freeWifi: 'Kostenloses WLAN',
      breakfastOptions: 'Frühstücksoptionen verfügbar',
      freeCancellation: 'Kostenlose Stornierung bei ausgewählten Tarifen',
      bestPrice: 'Bestpreis-Garantie',
      checkAvailabilityPrices: 'Verfügbarkeit und Preise prüfen',
      loading: 'Wird geladen...',
      changeDates: 'Daten ändern',
      secureByBeds24: 'Sichere Buchung über Beds24',
      pricesIncludeTaxes: 'Alle Preise inkl. Steuern'
    },
    
    // Flash Deal
    flashDeal: {
      extraDiscount: 'Extra 5% RABATT — Buchen Sie in den nächsten'
    },

    // Social Media
    social: {
      title: 'Folgen Sie unserer Reise',
      subtitle: 'Verbinden Sie sich mit uns',
      description: 'Bleiben Sie auf dem Laufenden mit den neuesten Nachrichten aus dem Hotel Uma Premium. Folgen Sie uns für exklusive Angebote, Einblicke hinter die Kulissen und Reise-Inspiration.',
      instagramDesc: 'Wunderschöne Fotos von unserem Hotel, Zimmern, Pool und der bezaubernden Stadt Ulcinj.',
      facebookDesc: 'Updates, Gästebewertungen, Sonderangebote und Community-Engagement.',
      tiktokDesc: 'Unterhaltsame Videos, virtuelle Touren und Einblicke in das Leben im Hotel Uma Premium.',
      followInstagram: 'Auf Instagram folgen',
      followFacebook: 'Auf Facebook liken',
      followTiktok: 'Auf TikTok folgen',
      shareExperience: 'Teilen Sie Ihre Erfahrung mit uns:',
      viewInstagramProfile: 'Vollständiges Profil auf Instagram ansehen'
    },
    
    // Virtual Tour
    virtualTour: {
      title: '360° Virtuelle Tour',
      subtitle: 'Immersives Erlebnis',
      description: 'Erkunden Sie jeden Winkel des Hotel Uma Premium bequem von zu Hause aus. Navigieren Sie durch unsere wunderschönen Räume mit interaktiven 360°-Ansichten.',
      exterior: 'Hotel Außenansicht',
      exteriorDesc: 'Erkunden Sie unser schönes Hotelgebäude und den Eingang',
      pool: 'Dachpool',
      poolDesc: 'Erleben Sie unseren atemberaubenden Dachpool mit Panoramablick',
      restaurant: 'Restaurant',
      restaurantDesc: 'Entdecken Sie unseren eleganten Speisebereich mit köstlicher Küche',
      reception: 'Rezeption und Lobby',
      receptionDesc: 'Willkommen in unserer modernen Rezeption und gemütlichen Lobby',
      rooms: 'Gästezimmer',
      roomsDesc: 'Besichtigen Sie unsere komfortablen und gut ausgestatteten Gästezimmer',
      apartments: 'Apartments',
      apartmentsDesc: 'Erkunden Sie unsere geräumigen Apartments mit vollständiger Ausstattung',
      loading: '360°-Ansicht wird geladen...',
      dragToExplore: 'Ziehen zum Erkunden • Scrollen zum Zoomen',
      openFullTour: 'Vollständige 360°-Tour in Google Maps öffnen'
    },
    
    // Special Offer
    specialOffer: {
      title: 'Sonderangebot',
      discount: '10% Rabatt',
      description: 'Buchen Sie direkt und sparen Sie! Erhalten Sie 10% Rabatt auf alle Zimmer bei Buchung über unsere Website.',
      bookDirect: 'Direkt buchen',
      limitedTime: 'Zeitlich begrenztes Angebot'
    },
    
    // Best Price Guarantee
    bestPrice: {
      badge: 'Bestpreis-Garantie',
      title: 'Bestpreis-Garantie',
      description: 'Buchen Sie direkt bei uns und erhalten Sie den besten verfügbaren Preis. Wenn Sie woanders einen günstigeren Preis finden, gleichen wir ihn an!'
    },
    
    // Why Book Direct
    whyBookDirect: {
      exclusive: 'Exklusive Vorteile',
      title: 'Warum direkt buchen?',
      subtitle: 'Genießen Sie exklusive Vorteile bei Direktbuchung auf unserer Website',
      bestPrice: 'Bestpreis-Garantie',
      bestPriceDesc: 'Wir garantieren den niedrigsten Preis. Günstiger gefunden? Wir gleichen an!',
      discount: '10% Rabatt',
      discountDesc: 'Sparen Sie sofort 10% auf alle Zimmertypen bei Buchung über unsere Website.',
      freeCancellation: 'Flexible Stornierung',
      freeCancellationDesc: 'Pläne ändern sich. Genießen Sie kostenlose Stornierung bei den meisten Buchungen bis 24h vor Anreise.',
      directSupport: '24/7 Direkter Support',
      directSupportDesc: 'Fragen? Unser Team steht Ihnen rund um die Uhr direkt zur Verfügung.',
      bookNow: 'Direkt buchen & sparen'
    }
  },

  // POLISH (Polski)
  pl: {
    nav: {
      rooms: 'Pokoje',
      amenities: 'Udogodnienia',
      gallery: 'Galeria',
      virtualTour: 'Wirtualna wycieczka 360°',
      location: 'Lokalizacja',
      reviews: 'Opinie',
      contact: 'Kontakt',
      bookNow: 'Zarezerwuj'
    },
    hero: {
      tagline: '4-gwiazdkowe doświadczenie w sercu Ulcinja',
      description: 'Hotel Uma Premium oferuje 4-gwiazdkowe doświadczenie z basenem na dachu, tarasem słonecznym, restauracją, barem i bezpłatnym WiFi. Goście mogą korzystać z płatnego transferu lotniskowego, salonu, windy, całodobowej recepcji, usług concierge, miejsc na zewnątrz, pokoi rodzinnych, śniadania w pokoju, obsługi pokojowej, wypożyczalni samochodów i biura turystycznego.',
      exploreRooms: 'Zobacz pokoje',
      viewGallery: 'Zobacz galerię',
      checkAvailability: 'Sprawdź dostępność i ceny',
      checkIn: 'Zameldowanie',
      checkOut: 'Wymeldowanie',
      guests: 'Goście',
      guest: 'Gość',
      searchAvailability: 'Szukaj dostępności',
      searching: 'Wyszukiwanie...',
      roomsAvailable: 'Dostępne pokoje na',
      night: 'noc',
      nights: 'nocy',
      scrollForPrices: 'Przewiń w dół, aby zobaczyć ceny',
      veryGood: 'Bardzo dobry',
      reviews: 'opinii'
    },
    rooms: {
      title: 'Nasze eleganckie pokoje',
      subtitle: 'Zakwaterowanie',
      description: 'Każdy pokój został starannie zaprojektowany, aby zapewnić idealną równowagę komfortu i luksusu.',
      yourStay: 'Twój pobyt',
      seeRealTimePrices: 'Zobacz ceny w czasie rzeczywistym',
      checkPriceBook: 'Sprawdź cenę i zarezerwuj',
      startingFrom: 'Od',
      priceLabel: 'Cijena',
      perNight: '/noc',
      forNights: 'Za',
      clickToSeePrice: 'Kliknij, aby zobaczyć dokładną cenę',
      available: 'Dostępny',
      soldOut: 'Wyprzedany',
      viewDetails: 'Zobacz szczegóły i zdjęcia',
      livePrice: 'Cena na żywo',
      roomInfo: 'Informacje o pokoju',
      roomRate: 'Cena pokoju',
      numberOfNights: 'Liczba nocy',
      dates: 'Daty',
      total: 'Razem',
      taxesIncluded: 'Podatki wliczone',
      checkPriceBookNow: 'Sprawdź cenę i zarezerwuj teraz',
      photos: 'zdjęć',
      onlyRoomsLeft: 'Tylko {n} pozostało w tej cenie',
      viewingNow: '{n} osób ogląda teraz',
      bookedToday: 'Zarezerwowano {n}x dzisiaj',
      directPrice: 'Bezpośrednio',
      savePercent: 'OSZCZĘDŹ {n}%',
      saveAmount: 'Oszczędzasz {n} za noc '
    },
    roomTypes: {
      economyDouble: 'Pokój dwuosobowy Budget z balkonem',
      economyDoubleDesc: 'Kompaktowy pokój 15 m² z balkonem, idealny dla oszczędnych podróżnych. Wygodne podwójne łóżko, telewizor z płaskim ekranem, bezpłatne WiFi, klimatyzacja i kosmetyki premium. Prywatna łazienka z prysznicem.',
      standardDouble: 'Pokój dwuosobowy z balkonem',
      standardDoubleDesc: 'Komfortowy pokój 17 m² z balkonem i nowoczesnym wyposażeniem: klimatyzacja, lodówka minibar, biurko, dźwiękoszczelne okna oraz prywatna łazienka z prysznicem i suszarką.',
      superiorDouble: 'Pokój dwuosobowy Comfort z balkonem',
      superiorDoubleDesc: 'Przestronny pokój 20 m² z eleganckim wyposażeniem: wygodne podwójne łóżko, balkon z widokiem, część wypoczynkowa, lodówka, biurko, minibar i podłoga z płytek.',
      tripleBalcony: 'Pokój trzyosobowy z balkonem',
      tripleBalconyDesc: 'Idealny dla rodzin lub grup znajomych — wygodnie pomieści 3 osoby dorosłe. Prywatny balkon, klimatyzacja i pełne nowoczesne wyposażenie.',
      oneBedApartment: 'Apartament rodzinny z balkonem',
      oneBedApartmentDesc: 'Przestronny apartament 45 m² dla rodzin i na dłuższe pobyty: oddzielna sypialnia, salon z sofą, w pełni wyposażony aneks kuchenny i prywatny balkon. Do 4 gości.',
      royalApartment: 'Apartament Premium',
      royalApartmentDesc: 'Nasze najbardziej luksusowe zakwaterowanie, 60 m²: przestronna część dzienna, eleganckie meble, pełna kuchnia i widok na miasto. Idealny dla rodzin i osób szukających dodatkowego komfortu. Do 5 gości.'
    },
    amenityNames: {
      airConditioning: 'Klimatyzacja',
      freeWifi: 'Bezpłatne WiFi',
      flatScreenTv: 'Telewizor z płaskim ekranem',
      privateBathroom: 'Prywatna łazienka',
      premiumToiletries: 'Kosmetyki premium',
      minibar: 'Minibar',
      writingDesk: 'Biurko',
      soundproofWindows: 'Okna dźwiękoszczelne',
      balcony: 'Balkon',
      cityView: 'Widok na miasto',
      seatingArea: 'Miejsce do siedzenia',
      familyFriendly: 'Przyjazny rodzinom',
      separateBedroom: 'Oddzielna sypialnia',
      kitchenette: 'Aneks kuchenny',
      fullKitchen: 'Pełna kuchnia',
      livingRoom: 'Salon',
      premiumFurnishings: 'Wyposażenie premium'
    },
    amenities: {
      title: 'Udogodnienia światowej klasy',
      subtitle: 'Luksus czeka',
      description: 'Ciesz się naszymi wyjątkowymi obiektami.',
      rooftopPool: 'Basen na dachu',
      rooftopPoolDesc: 'Wspaniały basen na dachu z panoramicznym widokiem',
      restaurantBar: 'Restauracja i bar',
      restaurantBarDesc: 'Restauracja na miejscu ze śniadaniem halal',
      freeParking: 'Bezpłatny parking',
      freeParkingDesc: 'Bezpieczny bezpłatny parking dla gości',
      sunTerrace: 'Taras słoneczny',
      sunTerraceDesc: 'Wspólny salon i taras słoneczny',
      airportShuttle: 'Transfer lotniskowy',
      airportShuttleDesc: 'Płatny transfer lotniskowy na życzenie',
      frontDesk: 'Recepcja 24h',
      frontDeskDesc: 'Całodobowa recepcja i obsługa pokojowa',
      experienceLuxury: 'Doświadcz śródziemnomorskiego luksusu',
      experienceLuxuryDesc: 'Pozwól nam stworzyć idealny pobyt.',
      contactConcierge: 'Skontaktuj się z concierge'
    },
    gallery: {
      title: 'Galeria',
      subtitle: 'Wizualna podróż',
      description: 'Odkryj piękno Hotelu Uma Premium.',
      all: 'Wszystko',
      pool: 'Basen',
      terrace: 'Taras',
      exterior: 'Zewnątrz',
      rooms: 'Pokoje',
      apartment: 'Apartament',
      dining: 'Jadalnia',
      bathroom: 'Łazienka',
      loadMore: 'Załaduj więcej',
      showAll: 'Pokaż wszystko',
      showing: 'Pokazuję',
      of: 'z',
      images: 'zdjęć'
    },
    location: {
      title: 'Doskonała lokalizacja',
      subtitle: 'Odkryj',
      description: 'Położony w sercu Ulcinja, najdalej wysuniętego na południe nadmorskiego klejnotu Czarnogóry.',
      nearbyAttractions: 'Pobliskie atrakcje',
      gettingHere: 'Jak dojechać',
      podgoricaAirport: 'Lotnisko Podgorica: 1,5 godziny jazdy',
      tiranaAirport: 'Lotnisko Tirana (Albania): 2 godziny jazdy',
      dubrovnikAirport: 'Lotnisko Dubrownik (Chorwacja): 2,5 godziny jazdy',
      minFromAirport: 'min od lotniska Podgorica',
      getDirections: 'Wyznacz trasę',
      openInMaps: 'Otwórz w Google Maps',
      loadingMap: 'Ładowanie mapy...',
      address: 'Nasz adres',
      airportShuttleAvailable: 'Transfer lotniskowy dostępny na życzenie'
    },
    attractions: {
      velikaPlaza: 'Velika Plaza (Długa Plaża)',
      velikaPlazaDesc: '13 km piaszczystej plaży - jedna z najdłuższych na Adriatyku',
      oldTown: 'Stare Miasto Ulcinj',
      oldTownDesc: 'Historyczna twierdza z zapierającymi dech widokami',
      malaPlaza: 'Mala Plaza (Mała Plaża)',
      malaPlazaDesc: 'Popularna miejska plaża z krystalicznie czystą wodą',
      adaBojana: 'Ada Bojana',
      adaBojanaDesc: 'Rajska wyspa rzeczna słynąca z kitesurfingu'
    },
    testimonials: {
      title: 'Doświadczenia gości',
      subtitle: 'Opinie',
      description: 'Posłuchaj, co nasi goście mówią o pobycie w Hotelu Uma Premium.',
      bookingRating: 'Ocena gości',
      reviews: 'Opinie',
      hotelRating: 'Ocena hotelu'
    },
    contact: {
      title: 'Skontaktuj się',
      subtitle: 'Kontakt',
      description: 'Masz pytania? Jesteśmy tu, aby pomóc.',
      contactInfo: 'Informacje kontaktowe',
      address: 'Adres',
      phone: 'Telefon',
      email: 'E-mail',
      receptionHours: 'Godziny recepcji',
      alwaysHere: '24/7 - Zawsze tu dla Ciebie',
      followUs: 'Obserwuj nas',
      whatsapp: 'Czat na WhatsApp',
      sendEmail: 'Wyślij e-mail'
    },
    departments: {
      subtitle: 'Działy',
      title: 'Sprzedaż · Kariera · Media',
      write: 'Napisz do nas',
      send: 'Wyślij wiadomość',
      thanks: 'Dziękujemy — wiadomość została wysłana.',
      name: 'Imię i nazwisko',
      email: 'E-mail',
      phone: 'Telefon (opcjonalnie)',
      company: 'Firma / agencja',
      outlet: 'Redakcja',
      position: 'Stanowisko, o które się ubiegasz',
      cvUrl: 'Link do CV lub LinkedIn (https://…)',
      cvAttach: 'Załącz CV (PDF, DOC, DOCX)',
      cvUploading: 'Przesyłanie…',
      cvHint: 'maks. 5 MB — lub wklej link poniżej',
      cvTooBig: 'Plik jest większy niż 5 MB.',
      pressKit: 'Materiały prasowe (ZIP)',
      factSheet: 'Fakty (PDF)',
      subject: 'Temat',
      privacy: 'Twoje dane wykorzystujemy wyłącznie do odpowiedzi na tę wiadomość.',
      error: 'Coś poszło nie tak — spróbuj ponownie lub napisz do nas bezpośrednio.',
      sales: {
        title: 'Sprzedaż i grupy',
        short: 'Sprzedaż',
        description: 'Pobyty grupowe, touroperatorzy, biura podróży, stawki firmowe i wydarzenia.',
        placeholder: 'Opisz grupę, terminy, liczbę pokoi i specjalne wymagania…',
        reply: 'Nasz dział sprzedaży odpowiada w ciągu jednego dnia roboczego.',
      },
      jobs: {
        title: 'Kariera',
        short: 'Praca',
        description: 'Dołącz do zespołu — recepcja, housekeeping, kuchnia, restauracja i zarządzanie.',
        placeholder: 'Opowiedz o sobie, doświadczeniu i od kiedy możesz zacząć…',
        reply: 'Rozpatrujemy każdą aplikację i odezwiemy się.',
      },
      pr: {
        title: 'Media i PR',
        short: 'Media',
        description: 'Zapytania mediów, wizyty prasowe, wywiady, sesje foto i filmowe, partnerstwa.',
        placeholder: 'Opisz redakcję, temat i termin…',
        reply: 'Nasz kontakt PR wkrótce się odezwie.',
      },
    },
    footer: {
      description: 'Doświadcz idealnego połączenia śródziemnomorskiego uroku i nowoczesnego luksusu w pięknym Ulcinju.',
      quickLinks: 'Szybkie linki',
      legal: 'Prawne',
      contactUs: 'Skontaktuj się',
      roomsSuites: 'Pokoje i apartamenty',
      privacyPolicy: 'Polityka prywatności',
      termsConditions: 'Regulamin',
      cookiePolicy: 'Polityka cookies',
      cancellationPolicy: 'Polityka anulowania',
      allRights: 'Wszelkie prawa zastrzeżone.',
      backToTop: 'Powrót na górę',
      starHotel: 'Hotel 4-gwiazdkowy'
    },
    booking: {
      secureBooking: 'Bezpieczna rezerwacja online',
      selectDates: 'Wybierz daty',
      realTimeAvailability: 'Dostępność i ceny w czasie rzeczywistym',
      realTimeDesc: 'Zobacz ceny na żywo i dostępne pokoje',
      whatsIncluded: 'Co jest wliczone',
      freeWifi: 'Bezpłatne szybkie WiFi',
      breakfastOptions: 'Opcje śniadaniowe',
      freeCancellation: 'Bezpłatne anulowanie',
      bestPrice: 'Gwarancja najlepszej ceny',
      checkAvailabilityPrices: 'Sprawdź dostępność i ceny',
      loading: 'Ładowanie...',
      changeDates: 'Zmień daty',
      secureByBeds24: 'Bezpieczna rezerwacja przez Beds24',
      pricesIncludeTaxes: 'Wszystkie ceny zawierają podatki',
      yourStay: 'Twój pobyt',
      night: 'noc',
      nights: 'nocy',
      startingFrom: 'Od',
      priceLabel: 'Cijena',
      securePayment: 'Bezpieczna płatność',
      instantConfirmation: 'Natychmiastowe potwierdzenie',
      loadingRooms: 'Ładowanie dostępnych pokoi...',
      pleaseWait: 'Proszę czekać'
    },
    // Flash Deal
    flashDeal: {
      extraDiscount: 'Dodatkowe 5% ZNIŻKI — Zarezerwuj w ciągu'
    },
    social: {
      title: 'Śledź naszą podróż',
      subtitle: 'Połącz się z nami',
      description: 'Bądź na bieżąco z najnowszymi wiadomościami z Hotelu Uma Premium.',
      instagramDesc: 'Piękne zdjęcia z naszego hotelu.',
      facebookDesc: 'Aktualności, opinie gości, oferty specjalne.',
      tiktokDesc: 'Zabawne filmy i wirtualne wycieczki.',
      followInstagram: 'Obserwuj na Instagramie',
      followFacebook: 'Polub na Facebooku',
      followTiktok: 'Obserwuj na TikToku',
      shareExperience: 'Podziel się swoim doświadczeniem:',
      viewInstagramProfile: 'Zobacz pełny profil na Instagramie'
    },
    virtualTour: {
      title: 'Wirtualna wycieczka 360°',
      subtitle: 'Immersyjne doświadczenie',
      description: 'Odkryj każdy zakątek Hotelu Uma Premium z wygody swojego domu.',
      exterior: 'Zewnątrz hotelu',
      exteriorDesc: 'Odkryj nasz piękny budynek hotelowy',
      pool: 'Basen na dachu',
      poolDesc: 'Doświadcz naszego wspaniałego basenu na dachu',
      restaurant: 'Restauracja',
      restaurantDesc: 'Odkryj naszą elegancką jadalnię',
      reception: 'Recepcja i lobby',
      receptionDesc: 'Witamy w naszej nowoczesnej recepcji',
      rooms: 'Pokoje gościnne',
      roomsDesc: 'Zwiedzaj nasze komfortowe pokoje',
      apartments: 'Apartamenty',
      apartmentsDesc: 'Odkryj nasze przestronne apartamenty',
      loading: 'Ładowanie widoku 360°...',
      dragToExplore: 'Przeciągnij, aby zwiedzać • Przewiń, aby powiększyć',
      openFullTour: 'Otwórz pełną wycieczkę 360° w Google Maps'
    },
    specialOffer: {
      title: 'Oferta specjalna',
      discount: '10% ZNIŻKI',
      description: 'Zarezerwuj bezpośrednio i zaoszczędź! Otrzymaj 10% zniżki na wszystkie pokoje.',
      bookDirect: 'Zarezerwuj bezpośrednio',
      limitedTime: 'Oferta ograniczona czasowo'
    },
    bestPrice: {
      badge: 'Gwarancja najlepszej ceny',
      title: 'Gwarancja najlepszej ceny',
      description: 'Zarezerwuj bezpośrednio u nas i uzyskaj najlepszą dostępną cenę.'
    },
    whyBookDirect: {
      exclusive: 'Ekskluzywne korzyści',
      title: 'Dlaczego rezerwować bezpośrednio?',
      subtitle: 'Ciesz się ekskluzywnymi korzyściami przy rezerwacji na naszej stronie',
      bestPrice: 'Gwarancja najlepszej ceny',
      bestPriceDesc: 'Gwarantujemy najniższą cenę. Znajdziesz taniej? Wyrównamy!',
      discount: '10% zniżki',
      discountDesc: 'Zaoszczędź natychmiast 10% na wszystkich typach pokoi.',
      freeCancellation: 'Elastyczne anulowanie',
      freeCancellationDesc: 'Plany się zmieniają. Bezpłatne anulowanie do 24h przed przyjazdem.',
      directSupport: 'Wsparcie 24/7',
      directSupportDesc: 'Pytania? Nasz zespół jest dostępny całą dobę.',
      bookNow: 'Zarezerwuj bezpośrednio i zaoszczędź'
    }
  },

  // RUSSIAN (Русский)
  ru: {
    nav: {
      rooms: 'Номера',
      amenities: 'Удобства',
      gallery: 'Галерея',
      virtualTour: '360° Тур',
      location: 'Расположение',
      reviews: 'Отзывы',
      contact: 'Контакты',
      bookNow: 'Забронировать'
    },
    hero: {
      tagline: '4-звездочный отдых в сердце Ульциня',
      description: 'Отель Uma Premium предлагает 4-звездочный отдых с бассейном на крыше, солнечной террасой, рестораном, баром и бесплатным WiFi. Гости могут воспользоваться платным трансфером из аэропорта, лаунжем, лифтом, круглосуточной стойкой регистрации, услугами консьержа, открытыми площадками, семейными номерами, завтраком в номер, обслуживанием номеров, прокатом автомобилей и туристическим бюро.',
      exploreRooms: 'Смотреть номера',
      viewGallery: 'Смотреть галерею',
      checkAvailability: 'Проверить наличие и цены',
      checkIn: 'Заезд',
      checkOut: 'Выезд',
      guests: 'Гости',
      guest: 'Гость',
      searchAvailability: 'Поиск наличия',
      searching: 'Поиск...',
      roomsAvailable: 'Доступные номера на',
      night: 'ночь',
      nights: 'ночей',
      scrollForPrices: 'Прокрутите вниз для просмотра цен',
      veryGood: 'Очень хорошо',
      reviews: 'отзывов'
    },
    rooms: {
      title: 'Наши элегантные номера',
      subtitle: 'Размещение',
      description: 'Каждый номер тщательно спроектирован для идеального баланса комфорта и роскоши.',
      yourStay: 'Ваше проживание',
      seeRealTimePrices: 'Смотрите цены в реальном времени',
      checkPriceBook: 'Узнать цену и забронировать',
      startingFrom: 'От',
      priceLabel: 'Цена',
      perNight: '/ночь',
      forNights: 'За',
      clickToSeePrice: 'Нажмите для точной цены',
      available: 'Доступен',
      soldOut: 'Продан',
      viewDetails: 'Подробности и фото',
      livePrice: 'Актуальная цена',
      roomInfo: 'Информация о номере',
      roomRate: 'Стоимость номера',
      numberOfNights: 'Количество ночей',
      dates: 'Даты',
      total: 'Итого',
      taxesIncluded: 'Налоги включены',
      checkPriceBookNow: 'Узнать цену и забронировать',
      photos: 'фото',
      onlyRoomsLeft: 'Только {n} осталось по этой цене',
      viewingNow: '{n} человек смотрят сейчас',
      bookedToday: 'Забронировано {n}x сегодня',
      directPrice: 'Напрямую',
      savePercent: 'СКИДКА {n}%',
      saveAmount: 'Вы экономите {n} за ночь '
    },
    roomTypes: {
      economyDouble: 'Двухместный номер Budget с балконом',
      economyDoubleDesc: 'Компактный номер 15 м² с балконом — идеален для экономных путешественников. Удобная двуспальная кровать, телевизор с плоским экраном, бесплатный Wi-Fi, кондиционер и косметика премиум-класса. Собственная ванная комната с душем.',
      standardDouble: 'Двухместный номер с балконом',
      standardDoubleDesc: 'Комфортный номер 17 м² с балконом и современным оснащением: кондиционер, мини-бар-холодильник, письменный стол, звукоизолированные окна, собственная ванная с душем и феном.',
      superiorDouble: 'Двухместный номер Comfort с балконом',
      superiorDoubleDesc: 'Просторный номер 20 м² с премиальной обстановкой: удобная двуспальная кровать, балкон с видом, зона отдыха, холодильник, рабочий стол, мини-бар и плиточный пол.',
      tripleBalcony: 'Трёхместный номер с балконом',
      tripleBalconyDesc: 'Идеален для семей и компаний друзей — с комфортом размещает 3 взрослых. Собственный балкон, кондиционер и всё современное оснащение.',
      oneBedApartment: 'Семейные апартаменты с балконом',
      oneBedApartmentDesc: 'Просторные апартаменты 45 м² для семей и длительного отдыха: отдельная спальня, гостиная с диваном, полностью оборудованная мини-кухня и собственный балкон. До 4 гостей.',
      royalApartment: 'Апартаменты Premium',
      royalApartmentDesc: 'Наше самое роскошное размещение, 60 м²: просторная гостиная, премиальная мебель, полноценная кухня и вид на город. Идеально для семей и тех, кто ценит дополнительный комфорт. До 5 гостей.'
    },
    amenityNames: {
      airConditioning: 'Кондиционер',
      freeWifi: 'Бесплатный WiFi',
      flatScreenTv: 'Телевизор с плоским экраном',
      privateBathroom: 'Собственная ванная',
      premiumToiletries: 'Туалетные принадлежности премиум',
      minibar: 'Мини-бар',
      writingDesk: 'Письменный стол',
      soundproofWindows: 'Звукоизоляция',
      balcony: 'Балкон',
      cityView: 'Вид на город',
      seatingArea: 'Зона отдыха',
      familyFriendly: 'Для семей',
      separateBedroom: 'Отдельная спальня',
      kitchenette: 'Мини-кухня',
      fullKitchen: 'Полноценная кухня',
      livingRoom: 'Гостиная',
      premiumFurnishings: 'Премиум мебель'
    },
    amenities: {
      title: 'Удобства мирового класса',
      subtitle: 'Роскошь ждет',
      description: 'Наслаждайтесь нашими исключительными удобствами.',
      rooftopPool: 'Бассейн на крыше',
      rooftopPoolDesc: 'Потрясающий бассейн с панорамным видом',
      restaurantBar: 'Ресторан и бар',
      restaurantBarDesc: 'Ресторан с халяльным завтраком',
      freeParking: 'Бесплатная парковка',
      freeParkingDesc: 'Бесплатная охраняемая парковка для гостей',
      sunTerrace: 'Солнечная терраса',
      sunTerraceDesc: 'Общий лаундж и солнечная терраса',
      airportShuttle: 'Трансфер из аэропорта',
      airportShuttleDesc: 'Платный трансфер по запросу',
      frontDesk: 'Круглосуточная стойка регистрации',
      frontDeskDesc: 'Круглосуточная стойка регистрации и обслуживание номеров',
      experienceLuxury: 'Испытайте средиземноморскую роскошь',
      experienceLuxuryDesc: 'Позвольте нам создать идеальный отдых.',
      contactConcierge: 'Связаться с консьержем'
    },
    gallery: {
      title: 'Галерея',
      subtitle: 'Визуальное путешествие',
      description: 'Откройте красоту отеля Uma Premium.',
      all: 'Все',
      pool: 'Бассейн',
      terrace: 'Терраса',
      exterior: 'Экстерьер',
      rooms: 'Номера',
      apartment: 'Апартаменты',
      dining: 'Столовая',
      bathroom: 'Ванная',
      loadMore: 'Загрузить еще',
      showAll: 'Показать все',
      showing: 'Показано',
      of: 'из',
      images: 'изображений'
    },
    location: {
      title: 'Отличное расположение',
      subtitle: 'Откройте',
      description: 'Расположен в сердце Ульциня, самой южной прибрежной жемчужины Черногории.',
      nearbyAttractions: 'Достопримечательности поблизости',
      gettingHere: 'Как добраться',
      podgoricaAirport: 'Аэропорт Подгорица: 1,5 часа езды',
      tiranaAirport: 'Аэропорт Тирана (Албания): 2 часа езды',
      dubrovnikAirport: 'Аэропорт Дубровник (Хорватия): 2,5 часа езды',
      minFromAirport: 'мин от аэропорта Подгорица',
      getDirections: 'Проложить маршрут',
      openInMaps: 'Открыть в Google Maps',
      loadingMap: 'Загрузка карты...',
      address: 'Наш адрес',
      airportShuttleAvailable: 'Трансфер из аэропорта по запросу'
    },
    attractions: {
      velikaPlaza: 'Велика Плажа (Длинный пляж)',
      velikaPlazaDesc: '13 км песчаного пляжа - один из самых длинных на Адриатике',
      oldTown: 'Старый город Ульцинь',
      oldTownDesc: 'Историческая крепость с потрясающими видами',
      malaPlaza: 'Мала Плажа (Малый пляж)',
      malaPlazaDesc: 'Популярный городской пляж с кристально чистой водой',
      adaBojana: 'Ада Бояна',
      adaBojanaDesc: 'Райский речной остров, известный кайтсерфингом'
    },
    testimonials: {
      title: 'Отзывы гостей',
      subtitle: 'Отзывы',
      description: 'Узнайте, что наши гости говорят о проживании в отеле Uma Premium.',
      bookingRating: 'Рейтинг гостей',
      reviews: 'Отзывы',
      hotelRating: 'Рейтинг отеля'
    },
    contact: {
      title: 'Связаться с нами',
      subtitle: 'Контакты',
      description: 'Есть вопросы? Мы здесь, чтобы помочь.',
      contactInfo: 'Контактная информация',
      address: 'Адрес',
      phone: 'Телефон',
      email: 'Эл. почта',
      receptionHours: 'Часы работы рецепции',
      alwaysHere: '24/7 - Мы всегда здесь для вас',
      followUs: 'Подписывайтесь на нас',
      whatsapp: 'Чат в WhatsApp',
      sendEmail: 'Отправить письмо'
    },
    departments: {
      subtitle: 'Отделы',
      title: 'Продажи · Карьера · Пресса',
      write: 'Напишите нам',
      send: 'Отправить сообщение',
      thanks: 'Спасибо — ваше сообщение отправлено.',
      name: 'Имя и фамилия',
      email: 'E-mail',
      phone: 'Телефон (необязательно)',
      company: 'Компания / агентство',
      outlet: 'СМИ',
      position: 'Должность, на которую вы претендуете',
      cvUrl: 'Ссылка на резюме или LinkedIn (https://…)',
      cvAttach: 'Прикрепить резюме (PDF, DOC, DOCX)',
      cvUploading: 'Загрузка…',
      cvHint: 'макс. 5 МБ — или вставьте ссылку ниже',
      cvTooBig: 'Файл больше 5 МБ.',
      pressKit: 'Пресс-кит (ZIP)',
      factSheet: 'Факт-лист (PDF)',
      subject: 'Тема',
      privacy: 'Ваши данные используются только для ответа на это сообщение.',
      error: 'Что-то пошло не так — попробуйте снова или напишите нам напрямую.',
      sales: {
        title: 'Продажи и группы',
        short: 'Продажи',
        description: 'Групповые заезды, туроператоры, агентства, корпоративные тарифы и мероприятия.',
        placeholder: 'Расскажите о группе, датах, количестве номеров и особых пожеланиях…',
        reply: 'Отдел продаж отвечает в течение одного рабочего дня.',
      },
      jobs: {
        title: 'Карьера',
        short: 'Вакансии',
        description: 'Присоединяйтесь к команде — ресепшн, хаускипинг, кухня, ресторан и менеджмент.',
        placeholder: 'Расскажите о себе, опыте и когда вы могли бы начать…',
        reply: 'Мы рассматриваем каждую заявку и свяжемся с вами.',
      },
      pr: {
        title: 'Пресса и PR',
        short: 'Пресса',
        description: 'Запросы СМИ, пресс-визиты, интервью, фото- и видеосъёмка, партнёрства.',
        placeholder: 'Расскажите о вашем издании, теме и сроках…',
        reply: 'Наш PR-контакт скоро свяжется с вами.',
      },
    },
    footer: {
      description: 'Испытайте идеальное сочетание средиземноморского шарма и современной роскоши в красивом Ульцине.',
      quickLinks: 'Быстрые ссылки',
      legal: 'Правовая информация',
      contactUs: 'Связаться с нами',
      roomsSuites: 'Номера и апартаменты',
      privacyPolicy: 'Политика конфиденциальности',
      termsConditions: 'Условия использования',
      cookiePolicy: 'Политика cookies',
      cancellationPolicy: 'Политика отмены',
      allRights: 'Все права защищены.',
      backToTop: 'Наверх',
      starHotel: '4-звездочный отель'
    },
    booking: {
      secureBooking: 'Безопасное онлайн-бронирование',
      selectDates: 'Выберите даты',
      realTimeAvailability: 'Наличие и цены в реальном времени',
      realTimeDesc: 'Смотрите актуальные цены и доступные номера',
      whatsIncluded: 'Что включено',
      freeWifi: 'Бесплатный высокоскоростной WiFi',
      breakfastOptions: 'Варианты завтрака',
      freeCancellation: 'Бесплатная отмена',
      bestPrice: 'Гарантия лучшей цены',
      checkAvailabilityPrices: 'Проверить наличие и цены',
      loading: 'Загрузка...',
      changeDates: 'Изменить даты',
      secureByBeds24: 'Безопасное бронирование через Beds24',
      pricesIncludeTaxes: 'Все цены включают налоги',
      yourStay: 'Ваше проживание',
      night: 'ночь',
      nights: 'ночей',
      startingFrom: 'От',
      priceLabel: 'Цена',
      securePayment: 'Безопасная оплата',
      instantConfirmation: 'Мгновенное подтверждение',
      loadingRooms: 'Загрузка доступных номеров...',
      pleaseWait: 'Пожалуйста, подождите'
    },
    // Flash Deal
    flashDeal: {
      extraDiscount: 'Дополнительная СКИДКА 5% — Забронируйте в течение'
    },
    social: {
      title: 'Следите за нами',
      subtitle: 'Связаться с нами',
      description: 'Будьте в курсе последних новостей отеля Uma Premium.',
      instagramDesc: 'Красивые фото из нашего отеля.',
      facebookDesc: 'Новости, отзывы гостей, специальные предложения.',
      tiktokDesc: 'Веселые видео и виртуальные туры.',
      followInstagram: 'Подписаться в Instagram',
      followFacebook: 'Нравится в Facebook',
      followTiktok: 'Подписаться в TikTok',
      shareExperience: 'Поделитесь своим опытом:',
      viewInstagramProfile: 'Посмотреть профиль в Instagram'
    },
    virtualTour: {
      title: 'Виртуальный тур 360°',
      subtitle: 'Погружающий опыт',
      description: 'Исследуйте каждый уголок отеля Uma Premium не выходя из дома.',
      exterior: 'Экстерьер отеля',
      exteriorDesc: 'Исследуйте наше красивое здание отеля',
      pool: 'Бассейн на крыше',
      poolDesc: 'Испытайте наш потрясающий бассейн на крыше',
      restaurant: 'Ресторан',
      restaurantDesc: 'Откройте нашу элегантную столовую',
      reception: 'Рецепция и лобби',
      receptionDesc: 'Добро пожаловать в нашу современную рецепцию',
      rooms: 'Гостевые номера',
      roomsDesc: 'Осмотрите наши комфортные номера',
      apartments: 'Апартаменты',
      apartmentsDesc: 'Исследуйте наши просторные апартаменты',
      loading: 'Загрузка вида 360°...',
      dragToExplore: 'Перетащите для исследования • Прокрутите для увеличения',
      openFullTour: 'Открыть полный тур 360° в Google Maps'
    },
    specialOffer: {
      title: 'Специальное предложение',
      discount: 'СКИДКА 10%',
      description: 'Бронируйте напрямую и экономьте! Получите скидку 10% на все номера.',
      bookDirect: 'Забронировать напрямую',
      limitedTime: 'Ограниченное предложение'
    },
    bestPrice: {
      badge: 'Гарантия лучшей цены',
      title: 'Гарантия лучшей цены',
      description: 'Бронируйте напрямую у нас и получите лучшую доступную цену.'
    },
    whyBookDirect: {
      exclusive: 'Эксклюзивные преимущества',
      title: 'Почему бронировать напрямую?',
      subtitle: 'Наслаждайтесь эксклюзивными преимуществами при бронировании на нашем сайте',
      bestPrice: 'Гарантия лучшей цены',
      bestPriceDesc: 'Мы гарантируем самую низкую цену. Нашли дешевле? Мы сравняем!',
      discount: 'Скидка 10%',
      discountDesc: 'Мгновенная экономия 10% на все типы номеров.',
      freeCancellation: 'Гибкая отмена',
      freeCancellationDesc: 'Планы меняются. Бесплатная отмена за 24ч до заезда.',
      directSupport: 'Поддержка 24/7',
      directSupportDesc: 'Вопросы? Наша команда доступна круглосуточно.',
      bookNow: 'Забронировать напрямую и сэкономить'
    }
  },

  // HUNGARIAN (Magyar)
  hu: {
    nav: {
      rooms: 'Szobák',
      amenities: 'Szolgáltatások',
      gallery: 'Galéria',
      virtualTour: '360° Túra',
      location: 'Helyszín',
      reviews: 'Vélemények',
      contact: 'Kapcsolat',
      bookNow: 'Foglalás'
    },
    hero: {
      tagline: '4 csillagos élmény Ulcinj szívében',
      description: 'A Hotel Uma Premium 4 csillagos élményt kínál tetőmedencével, napozóterasszal, étteremmel, bárral és ingyenes WiFi-vel. Vendégeink fizetős repülőtéri transzfert, társalgót, liftet, 24 órás recepciót, concierge szolgáltatást, kültéri ülőhelyeket, családi szobákat, szobai reggelit, szobaszervízt, autókölcsönzést és turisztikai irodát vehetnek igénybe.',
      exploreRooms: 'Szobák megtekintése',
      viewGallery: 'Galéria megtekintése',
      checkAvailability: 'Elérhetőség és árak',
      checkIn: 'Bejelentkezés',
      checkOut: 'Kijelentkezés',
      guests: 'Vendégek',
      guest: 'Vendég',
      searchAvailability: 'Keresés',
      searching: 'Keresés...',
      roomsAvailable: 'Elérhető szobák',
      night: 'éjszaka',
      nights: 'éjszaka',
      scrollForPrices: 'Görgessen le az árakért',
      veryGood: 'Nagyon jó',
      reviews: 'vélemény'
    },
    rooms: {
      title: 'Elegáns szobáink',
      subtitle: 'Szállás',
      description: 'Minden szobát gondosan terveztünk a kényelem és luxus tökéletes egyensúlyának biztosítására.',
      yourStay: 'Tartózkodása',
      seeRealTimePrices: 'Valós idejű árak megtekintése',
      checkPriceBook: 'Ár és foglalás',
      startingFrom: 'Tól',
      priceLabel: 'Ár',
      perNight: '/éj',
      forNights: 'Ért',
      clickToSeePrice: 'Kattintson a pontos árért',
      available: 'Elérhető',
      soldOut: 'Elfogyott',
      viewDetails: 'Részletek és fotók',
      livePrice: 'Aktuális ár',
      roomInfo: 'Szoba információ',
      roomRate: 'Szoba ára',
      numberOfNights: 'Éjszakák száma',
      dates: 'Dátumok',
      total: 'Összesen',
      taxesIncluded: 'Adók tartalmazzák',
      checkPriceBookNow: 'Ár és azonnali foglalás',
      photos: 'fotó',
      onlyRoomsLeft: 'Csak {n} maradt ezen az áron',
      viewingNow: '{n} ember nézi most',
      bookedToday: 'Ma {n}x foglalták',
      directPrice: 'Közvetlen',
      savePercent: 'MEGTAKARÍTÁS {n}%',
      saveAmount: '{n} megtakarítás éjszakánként '
    },
    roomTypes: {
      economyDouble: 'Budget kétágyas szoba erkéllyel',
      economyDoubleDesc: 'Kompakt, 15 m²-es szoba erkéllyel – ideális a költségtudatos utazóknak. Kényelmes franciaágy, síkképernyős TV, ingyenes WiFi, légkondicionálás és prémium piperecikkek. Saját fürdőszoba zuhanyzóval.',
      standardDouble: 'Kétágyas szoba erkéllyel',
      standardDoubleDesc: 'Kényelmes, 17 m²-es szoba erkéllyel és modern felszereltséggel: légkondicionálás, minibár-hűtő, íróasztal, hangszigetelt ablakok, saját fürdőszoba zuhanyzóval és hajszárítóval.',
      superiorDouble: 'Komfort kétágyas szoba erkéllyel',
      superiorDoubleDesc: 'Tágas, 20 m²-es szoba prémium berendezéssel: kényelmes franciaágy, kilátásos erkély, ülősarok, hűtőszekrény, íróasztal, minibár és hidegburkolat.',
      tripleBalcony: 'Háromágyas szoba erkéllyel',
      tripleBalconyDesc: 'Ideális családoknak és baráti társaságoknak – kényelmesen elfér benne 3 felnőtt. Saját erkély, légkondicionálás és teljes modern felszereltség.',
      oneBedApartment: 'Családi apartman erkéllyel',
      oneBedApartmentDesc: 'Tágas, 45 m²-es apartman családoknak és hosszabb tartózkodásra: külön hálószoba, nappali kanapéval, teljesen felszerelt teakonyha és saját erkély. Legfeljebb 4 fő.',
      royalApartment: 'Prémium apartman',
      royalApartmentDesc: 'Legfényűzőbb szállásunk, 60 m²: tágas nappali, prémium bútorok, teljes konyha és városi kilátás. Tökéletes családoknak és mindazoknak, akik extra kényelemre vágynak. Legfeljebb 5 fő.'
    },
    amenityNames: {
      airConditioning: 'Légkondicionálás',
      freeWifi: 'Ingyenes WiFi',
      flatScreenTv: 'Síkképernyős TV',
      privateBathroom: 'Saját fürdőszoba',
      premiumToiletries: 'Prémium toilett-cikkek',
      minibar: 'Minibár',
      writingDesk: 'Íróasztal',
      soundproofWindows: 'Hangszigetelt ablakok',
      balcony: 'Erkély',
      cityView: 'Városi kilátás',
      seatingArea: 'Ülőrész',
      familyFriendly: 'Családbarát',
      separateBedroom: 'Külön hálószoba',
      kitchenette: 'Teakonyha',
      fullKitchen: 'Teljes konyha',
      livingRoom: 'Nappali',
      premiumFurnishings: 'Prémium berendezés'
    },
    amenities: {
      title: 'Világszínvonalú szolgáltatások',
      subtitle: 'Luxus vár',
      description: 'Élvezze kivételes létesítményeinket.',
      rooftopPool: 'Tetőmedence',
      rooftopPoolDesc: 'Lenyűgöző tetőmedence panorámás kilátással',
      restaurantBar: 'Étterem és bár',
      restaurantBarDesc: 'Helyszíni étterem halal reggelivel',
      freeParking: 'Ingyenes parkolás',
      freeParkingDesc: 'Ingyenes biztonságos parkolás vendégeinknek',
      sunTerrace: 'Napozóterasz',
      sunTerraceDesc: 'Közös társalgó és napozóterasz',
      airportShuttle: 'Reptéri transzfer',
      airportShuttleDesc: 'Fizetős reptéri transzfer kérésre',
      frontDesk: '24 órás recepció',
      frontDeskDesc: 'Non-stop recepció és szobaszervíz',
      experienceLuxury: 'Tapasztalja meg a mediterrán luxust',
      experienceLuxuryDesc: 'Engedje, hogy tökéletes tartózkodást hozzunk létre.',
      contactConcierge: 'Kapcsolat a concierge-zsel'
    },
    gallery: {
      title: 'Galéria',
      subtitle: 'Vizuális utazás',
      description: 'Fedezze fel a Hotel Uma Premium szépségét.',
      all: 'Mind',
      pool: 'Medence',
      terrace: 'Terasz',
      exterior: 'Külső',
      rooms: 'Szobák',
      apartment: 'Apartman',
      dining: 'Étkezés',
      bathroom: 'Fürdőszoba',
      loadMore: 'Több betöltése',
      showAll: 'Mind mutatása',
      showing: 'Megjelenítés',
      of: 'ból',
      images: 'kép'
    },
    location: {
      title: 'Kiváló elhelyezkedés',
      subtitle: 'Fedezze fel',
      description: 'Ulcinj szívében található, Montenegró legdélibb tengerparti gyöngyszeme.',
      nearbyAttractions: 'Közeli látnivalók',
      gettingHere: 'Megközelítés',
      podgoricaAirport: 'Podgorica repülőtér: 1,5 óra autóval',
      tiranaAirport: 'Tirana repülőtér (Albánia): 2 óra autóval',
      dubrovnikAirport: 'Dubrovnik repülőtér (Horvátország): 2,5 óra autóval',
      minFromAirport: 'perc Podgorica repülőtértől',
      getDirections: 'Útvonaltervezés',
      openInMaps: 'Megnyitás Google Mapsben',
      loadingMap: 'Térkép betöltése...',
      address: 'Címünk',
      airportShuttleAvailable: 'Reptéri transzfer kérésre elérhető'
    },
    attractions: {
      velikaPlaza: 'Velika Plaza (Nagy strand)',
      velikaPlazaDesc: '13 km homokos strand - az Adria egyik leghosszabbja',
      oldTown: 'Ulcinj óváros',
      oldTownDesc: 'Történelmi erőd lenyűgöző kilátással',
      malaPlaza: 'Mala Plaza (Kis strand)',
      malaPlazaDesc: 'Népszerű városi strand kristálytiszta vízzel',
      adaBojana: 'Ada Bojana',
      adaBojanaDesc: 'Paradicsomi folyami sziget, kiteszörfözéséről híres'
    },
    testimonials: {
      title: 'Vendégélmények',
      subtitle: 'Vélemények',
      description: 'Tudja meg, mit mondanak vendégeink a Hotel Uma Premium-ban töltött tartózkodásukról.',
      bookingRating: 'Vendégértékelés',
      reviews: 'Vélemények',
      hotelRating: 'Szálloda értékelés'
    },
    contact: {
      title: 'Lépjen kapcsolatba',
      subtitle: 'Kapcsolat',
      description: 'Kérdései vannak? Segítünk.',
      contactInfo: 'Elérhetőség',
      address: 'Cím',
      phone: 'Telefon',
      email: 'E-mail',
      receptionHours: 'Recepció nyitvatartás',
      alwaysHere: '24/7 - Mindig itt vagyunk Önnek',
      followUs: 'Kövessen minket',
      whatsapp: 'Chat WhatsAppon',
      sendEmail: 'E-mail küldése'
    },
    departments: {
      subtitle: 'Részlegek',
      title: 'Értékesítés · Karrier · Sajtó',
      write: 'Írjon nekünk',
      send: 'Üzenet küldése',
      thanks: 'Köszönjük — üzenetét elküldtük.',
      name: 'Teljes név',
      email: 'E-mail',
      phone: 'Telefon (opcionális)',
      company: 'Cég / ügynökség',
      outlet: 'Médium',
      position: 'Megpályázott pozíció',
      cvUrl: 'Link az önéletrajzhoz vagy LinkedIn-hez (https://…)',
      cvAttach: 'Önéletrajz csatolása (PDF, DOC, DOCX)',
      cvUploading: 'Feltöltés…',
      cvHint: 'max. 5 MB — vagy illesszen be egy linket alább',
      cvTooBig: 'A fájl nagyobb 5 MB-nál.',
      pressKit: 'Sajtóanyag (ZIP)',
      factSheet: 'Adatlap (PDF)',
      subject: 'Tárgy',
      privacy: 'Adatait csak az üzenet megválaszolásához használjuk.',
      error: 'Hiba történt — próbálja újra, vagy írjon nekünk közvetlenül.',
      sales: {
        title: 'Értékesítés és csoportok',
        short: 'Értékesítés',
        description: 'Csoportos tartózkodás, utazásszervezők, ügynökségek, vállalati árak és rendezvények.',
        placeholder: 'Írja le a csoportot, időpontokat, szobaszámot és a különleges igényeket…',
        reply: 'Értékesítési csapatunk egy munkanapon belül válaszol.',
      },
      jobs: {
        title: 'Karrier',
        short: 'Állás',
        description: 'Csatlakozzon csapatunkhoz — recepció, housekeeping, konyha, étterem és menedzsment.',
        placeholder: 'Mutatkozzon be, írjon tapasztalatáról és arról, mikor kezdhetne…',
        reply: 'Minden jelentkezést átnézünk, és jelentkezünk.',
      },
      pr: {
        title: 'Sajtó és PR',
        short: 'Sajtó',
        description: 'Médiamegkeresések, sajtólátogatások, interjúk, fotó- és filmforgatás, partnerségek.',
        placeholder: 'Írja le a médiumot, a témát és a határidőt…',
        reply: 'PR-kapcsolattartónk hamarosan jelentkezik.',
      },
    },
    footer: {
      description: 'Tapasztalja meg a mediterrán varázs és modern luxus tökéletes egyensúlyát a gyönyörű Ulcinjban.',
      quickLinks: 'Gyorslinkek',
      legal: 'Jogi',
      contactUs: 'Kapcsolat',
      roomsSuites: 'Szobák és lakosztályok',
      privacyPolicy: 'Adatvédelmi irányelvek',
      termsConditions: 'Feltételek',
      cookiePolicy: 'Cookie szabályzat',
      cancellationPolicy: 'Lemondási feltételek',
      allRights: 'Minden jog fenntartva.',
      backToTop: 'Vissza a tetejére',
      starHotel: '4 csillagos szálloda'
    },
    booking: {
      secureBooking: 'Biztonságos online foglalás',
      selectDates: 'Válassza ki a dátumokat',
      realTimeAvailability: 'Valós idejű elérhetőség és árak',
      realTimeDesc: 'Tekintse meg az élő árakat és elérhető szobákat',
      whatsIncluded: 'Mi tartozik bele',
      freeWifi: 'Ingyenes gyors WiFi',
      breakfastOptions: 'Reggeli opciók',
      freeCancellation: 'Ingyenes lemondás',
      bestPrice: 'Legjobb ár garancia',
      checkAvailabilityPrices: 'Elérhetőség és árak',
      loading: 'Betöltés...',
      changeDates: 'Dátumok módosítása',
      secureByBeds24: 'Biztonságos foglalás Beds24 által',
      pricesIncludeTaxes: 'Az árak tartalmazzák az adókat',
      yourStay: 'Tartózkodása',
      night: 'éjszaka',
      nights: 'éjszaka',
      startingFrom: 'Tól',
      priceLabel: 'Ár',
      securePayment: 'Biztonságos fizetés',
      instantConfirmation: 'Azonnali visszaigazolás',
      loadingRooms: 'Elérhető szobák betöltése...',
      pleaseWait: 'Kérem várjon'
    },
    // Flash Deal
    flashDeal: {
      extraDiscount: 'Extra 5% KEDVEZMÉNY — Foglaljon a következő időn belül'
    },
    social: {
      title: 'Kövesse utunkat',
      subtitle: 'Kapcsolódjon hozzánk',
      description: 'Maradjon naprakész a Hotel Uma Premium legfrissebb híreivel.',
      instagramDesc: 'Gyönyörű fotók szállodánkból.',
      facebookDesc: 'Hírek, vendégvélemények, különleges ajánlatok.',
      tiktokDesc: 'Szórakoztató videók és virtuális túrák.',
      followInstagram: 'Kövessen Instagramon',
      followFacebook: 'Kedvelje Facebookon',
      followTiktok: 'Kövessen TikTokon',
      shareExperience: 'Ossza meg élményét:',
      viewInstagramProfile: 'Teljes profil megtekintése az Instagramon'
    },
    virtualTour: {
      title: '360° Virtuális túra',
      subtitle: 'Magával ragadó élmény',
      description: 'Fedezze fel a Hotel Uma Premium minden szegletét otthonról.',
      exterior: 'Szálloda külső',
      exteriorDesc: 'Fedezze fel gyönyörű szállodaépületünket',
      pool: 'Tetőmedence',
      poolDesc: 'Tapasztalja meg lenyűgöző tetőmedencénket',
      restaurant: 'Étterem',
      restaurantDesc: 'Fedezze fel elegáns éttermünket',
      reception: 'Recepció és előcsarnok',
      receptionDesc: 'Üdvözöljük modern recepciónkon',
      rooms: 'Vendégszobák',
      roomsDesc: 'Tekintse meg kényelmes szobáinkat',
      apartments: 'Apartmanok',
      apartmentsDesc: 'Fedezze fel tágas apartmanainkat',
      loading: '360° nézet betöltése...',
      dragToExplore: 'Húzza a felfedezéshez • Görgessen a nagyításhoz',
      openFullTour: 'Teljes 360° túra megnyitása Google Mapsben'
    },
    specialOffer: {
      title: 'Különleges ajánlat',
      discount: '10% KEDVEZMÉNY',
      description: 'Foglaljon közvetlenül és spóroljon! Kapjon 10% kedvezményt minden szobára.',
      bookDirect: 'Közvetlen foglalás',
      limitedTime: 'Korlátozott idejű ajánlat'
    },
    bestPrice: {
      badge: 'Legjobb ár garancia',
      title: 'Legjobb ár garancia',
      description: 'Foglaljon közvetlenül nálunk és kapja a legjobb elérhető árat.'
    },
    whyBookDirect: {
      exclusive: 'Exkluzív előnyök',
      title: 'Miért foglaljon közvetlenül?',
      subtitle: 'Élvezze az exkluzív előnyöket weboldalunkon történő foglalásnál',
      bestPrice: 'Legjobb ár garancia',
      bestPriceDesc: 'Garantáljuk a legalacsonyabb árat. Olcsóbbat talált? Megegyezünk!',
      discount: '10% kedvezmény',
      discountDesc: 'Azonnali 10% megtakarítás minden szobatípusnál.',
      freeCancellation: 'Rugalmas lemondás',
      freeCancellationDesc: 'A tervek változhatnak. Ingyenes lemondás érkezés előtt 24 óráig.',
      directSupport: '24/7 Közvetlen támogatás',
      directSupportDesc: 'Kérdések? Csapatunk éjjel-nappal elérhető.',
      bookNow: 'Foglaljon közvetlenül és spóroljon'
    }
  },

  // ROMANIAN (Română)
  ro: {
    nav: {
      rooms: 'Camere',
      amenities: 'Facilități',
      gallery: 'Galerie',
      virtualTour: 'Tur Virtual 360°',
      location: 'Locație',
      reviews: 'Recenzii',
      contact: 'Contact',
      bookNow: 'Rezervă'
    },
    hero: {
      tagline: 'Experiență de 4 stele în inima Ulcinjului',
      description: 'Hotelul Uma Premium oferă o experiență de 4 stele cu piscină pe acoperiș, terasă însorită, restaurant, bar și WiFi gratuit. Oaspeții beneficiază de transfer aeroport cu plată, salon, lift, recepție 24h, servicii concierge, locuri în aer liber, camere de familie, mic dejun în cameră, room service, închirieri auto și birou turistic.',
      exploreRooms: 'Explorează camerele',
      viewGallery: 'Vezi galeria',
      checkAvailability: 'Verifică disponibilitatea și prețurile',
      checkIn: 'Check-in',
      checkOut: 'Check-out',
      guests: 'Oaspeți',
      guest: 'Oaspete',
      searchAvailability: 'Caută disponibilitate',
      searching: 'Se caută...',
      roomsAvailable: 'Camere disponibile pentru',
      night: 'noapte',
      nights: 'nopți',
      scrollForPrices: 'Derulați în jos pentru prețuri',
      veryGood: 'Foarte bine',
      reviews: 'recenzii'
    },
    rooms: {
      title: 'Camerele noastre elegante',
      subtitle: 'Cazare',
      description: 'Fiecare cameră este proiectată cu grijă pentru echilibrul perfect între confort și lux.',
      yourStay: 'Sejurul dvs.',
      seeRealTimePrices: 'Vedeți prețurile în timp real',
      checkPriceBook: 'Verifică prețul și rezervă',
      startingFrom: 'De la',
      priceLabel: 'Preț',
      perNight: '/noapte',
      forNights: 'Pentru',
      clickToSeePrice: 'Click pentru preț exact',
      available: 'Disponibil',
      soldOut: 'Epuizat',
      viewDetails: 'Detalii și fotografii',
      livePrice: 'Preț actual',
      roomInfo: 'Informații cameră',
      roomRate: 'Tarif cameră',
      numberOfNights: 'Număr de nopți',
      dates: 'Date',
      total: 'Total',
      taxesIncluded: 'Taxe incluse',
      checkPriceBookNow: 'Verifică prețul și rezervă acum',
      photos: 'fotografii',
      onlyRoomsLeft: 'Doar {n} rămase la acest preț',
      viewingNow: '{n} persoane vizualizează acum',
      bookedToday: 'Rezervat de {n}x astăzi',
      directPrice: 'Direct',
      savePercent: 'ECONOMISEȘTI {n}%',
      saveAmount: 'Economisești {n} pe noapte '
    },
    roomTypes: {
      economyDouble: 'Cameră dublă Budget cu balcon',
      economyDoubleDesc: 'Cameră compactă de 15 m² cu balcon, ideală pentru călătorii atenți la buget. Pat dublu confortabil, TV cu ecran plat, WiFi gratuit, aer condiționat și produse cosmetice premium. Baie privată cu duș.',
      standardDouble: 'Cameră dublă cu balcon',
      standardDoubleDesc: 'Cameră confortabilă de 17 m² cu balcon și dotări moderne: aer condiționat, frigider minibar, birou, ferestre fonoizolate și baie privată cu duș și uscător de păr.',
      superiorDouble: 'Cameră dublă Comfort cu balcon',
      superiorDoubleDesc: 'Cameră spațioasă de 20 m² cu mobilier premium: pat dublu confortabil, balcon cu vedere, zonă de relaxare, frigider, birou, minibar și pardoseală cu gresie.',
      tripleBalcony: 'Cameră triplă cu balcon',
      tripleBalconyDesc: 'Ideală pentru familii sau grupuri de prieteni — găzduiește confortabil 3 adulți. Balcon privat, aer condiționat și toate dotările moderne.',
      oneBedApartment: 'Apartament familial cu balcon',
      oneBedApartmentDesc: 'Apartament spațios de 45 m² pentru familii și sejururi lungi: dormitor separat, living cu canapea, chicinetă complet utilată și balcon privat. Până la 4 oaspeți.',
      royalApartment: 'Apartament Premium',
      royalApartmentDesc: 'Cea mai luxoasă cazare a noastră, 60 m²: living spațios, mobilier premium, bucătărie completă și vedere spre oraș. Perfect pentru familii și pentru cei care își doresc confort suplimentar. Până la 5 oaspeți.'
    },
    amenityNames: {
      airConditioning: 'Aer condiționat',
      freeWifi: 'WiFi gratuit',
      flatScreenTv: 'TV cu ecran plat',
      privateBathroom: 'Baie privată',
      premiumToiletries: 'Articole de toaletă premium',
      minibar: 'Minibar',
      writingDesk: 'Birou',
      soundproofWindows: 'Ferestre insonorizate',
      balcony: 'Balcon',
      cityView: 'Vedere la oraș',
      seatingArea: 'Zonă de relaxare',
      familyFriendly: 'Prietenos cu familiile',
      separateBedroom: 'Dormitor separat',
      kitchenette: 'Chicinentă',
      fullKitchen: 'Bucătărie completă',
      livingRoom: 'Living',
      premiumFurnishings: 'Mobilier premium'
    },
    amenities: {
      title: 'Facilități de clasă mondială',
      subtitle: 'Luxul vă așteaptă',
      description: 'Bucurați-vă de facilitățile noastre excepționale.',
      rooftopPool: 'Piscină pe acoperiș',
      rooftopPoolDesc: 'Piscină uimitoare pe acoperiș cu vedere panoramică',
      restaurantBar: 'Restaurant și bar',
      restaurantBarDesc: 'Restaurant cu mic dejun halal bufet',
      freeParking: 'Parcare gratuită',
      freeParkingDesc: 'Parcare securizată gratuită pentru oaspeți',
      sunTerrace: 'Terasă însorită',
      sunTerraceDesc: 'Salon comun și terasă însorită',
      airportShuttle: 'Transfer aeroport',
      airportShuttleDesc: 'Transfer aeroport cu plată la cerere',
      frontDesk: 'Recepție 24h',
      frontDeskDesc: 'Recepție non-stop și room service',
      experienceLuxury: 'Experimentați luxul mediteranean',
      experienceLuxuryDesc: 'Lăsați-ne să creăm sejurul perfect.',
      contactConcierge: 'Contactați concierge'
    },
    gallery: {
      title: 'Galerie',
      subtitle: 'Călătorie vizuală',
      description: 'Descoperiți frumusețea Hotelului Uma Premium.',
      all: 'Toate',
      pool: 'Piscină',
      terrace: 'Terasă',
      exterior: 'Exterior',
      rooms: 'Camere',
      apartment: 'Apartament',
      dining: 'Dining',
      bathroom: 'Baie',
      loadMore: 'Încarcă mai multe',
      showAll: 'Arată toate',
      showing: 'Se afișează',
      of: 'din',
      images: 'imagini'
    },
    location: {
      title: 'Locație excelentă',
      subtitle: 'Descoperiți',
      description: 'Situat în inima Ulcinjului, bijuteria costieră cea mai sudică a Muntenegrului.',
      nearbyAttractions: 'Atracții în apropiere',
      gettingHere: 'Cum ajungeți',
      podgoricaAirport: 'Aeroportul Podgorica: 1,5 ore cu mașina',
      tiranaAirport: 'Aeroportul Tirana (Albania): 2 ore cu mașina',
      dubrovnikAirport: 'Aeroportul Dubrovnik (Croația): 2,5 ore cu mașina',
      minFromAirport: 'min de la aeroportul Podgorica',
      getDirections: 'Obține direcții',
      openInMaps: 'Deschide în Google Maps',
      loadingMap: 'Se încarcă harta...',
      address: 'Adresa noastră',
      airportShuttleAvailable: 'Transfer aeroport disponibil la cerere'
    },
    attractions: {
      velikaPlaza: 'Velika Plaza (Plaja Mare)',
      velikaPlazaDesc: '13 km de plajă cu nisip - una dintre cele mai lungi de pe Adriatică',
      oldTown: 'Orașul Vechi Ulcinj',
      oldTownDesc: 'Cetate istorică cu vedere uluitoare',
      malaPlaza: 'Mala Plaza (Plaja Mică)',
      malaPlazaDesc: 'Plajă urbană populară cu apă cristalină',
      adaBojana: 'Ada Bojana',
      adaBojanaDesc: 'Insulă fluvială paradisiacă, faimoasă pentru kitesurfing'
    },
    testimonials: {
      title: 'Experiențele oaspeților',
      subtitle: 'Recenzii',
      description: 'Aflați ce spun oaspeții noștri despre sejurul la Hotelul Uma Premium.',
      bookingRating: 'Recenziile oaspeților',
      reviews: 'Recenzii',
      hotelRating: 'Rating hotel'
    },
    contact: {
      title: 'Contactați-ne',
      subtitle: 'Contact',
      description: 'Aveți întrebări? Suntem aici să ajutăm.',
      contactInfo: 'Informații de contact',
      address: 'Adresă',
      phone: 'Telefon',
      email: 'E-mail',
      receptionHours: 'Ore recepție',
      alwaysHere: '24/7 - Suntem mereu aici pentru dvs.',
      followUs: 'Urmăriți-ne',
      whatsapp: 'Chat pe WhatsApp',
      sendEmail: 'Trimite e-mail'
    },
    departments: {
      subtitle: 'Departamente',
      title: 'Vânzări · Carieră · Presă',
      write: 'Scrieți-ne',
      send: 'Trimite mesajul',
      thanks: 'Mulțumim — mesajul a fost trimis.',
      name: 'Nume complet',
      email: 'E-mail',
      phone: 'Telefon (opțional)',
      company: 'Companie / agenție',
      outlet: 'Publicație',
      position: 'Postul pentru care aplicați',
      cvUrl: 'Link către CV sau LinkedIn (https://…)',
      cvAttach: 'Atașați CV-ul (PDF, DOC, DOCX)',
      cvUploading: 'Se încarcă…',
      cvHint: 'max. 5 MB — sau lipiți un link mai jos',
      cvTooBig: 'Fișierul depășește 5 MB.',
      pressKit: 'Kit de presă (ZIP)',
      factSheet: 'Fișă de date (PDF)',
      subject: 'Subiect',
      privacy: 'Folosim datele dvs. doar pentru a răspunde acestui mesaj.',
      error: 'Ceva nu a funcționat — încercați din nou sau scrieți-ne direct.',
      sales: {
        title: 'Vânzări și grupuri',
        short: 'Vânzări',
        description: 'Sejururi de grup, touroperatori, agenții, tarife corporate și evenimente.',
        placeholder: 'Descrieți grupul, datele, numărul de camere și cerințele speciale…',
        reply: 'Echipa de vânzări răspunde în cel mult o zi lucrătoare.',
      },
      jobs: {
        title: 'Carieră',
        short: 'Joburi',
        description: 'Alăturați-vă echipei — recepție, housekeeping, bucătărie, restaurant și management.',
        placeholder: 'Spuneți-ne despre dvs., experiența și când ați putea începe…',
        reply: 'Analizăm fiecare aplicație și vă vom contacta.',
      },
      pr: {
        title: 'Presă și PR',
        short: 'Presă',
        description: 'Solicitări media, vizite de presă, interviuri, ședințe foto și filmări, parteneriate.',
        placeholder: 'Descrieți publicația, subiectul și termenul…',
        reply: 'Contactul nostru PR vă va răspunde în curând.',
      },
    },
    footer: {
      description: 'Experimentați combinația perfectă de farmec mediteranean și lux modern în frumosul Ulcinj.',
      quickLinks: 'Linkuri rapide',
      legal: 'Legal',
      contactUs: 'Contactați-ne',
      roomsSuites: 'Camere și apartamente',
      privacyPolicy: 'Politica de confidențialitate',
      termsConditions: 'Termeni și condiții',
      cookiePolicy: 'Politica cookies',
      cancellationPolicy: 'Politica de anulare',
      allRights: 'Toate drepturile rezervate.',
      backToTop: 'Înapoi sus',
      starHotel: 'Hotel 4 stele'
    },
    booking: {
      secureBooking: 'Rezervare online securizată',
      selectDates: 'Selectați datele',
      realTimeAvailability: 'Disponibilitate și prețuri în timp real',
      realTimeDesc: 'Vedeți prețurile live și camerele disponibile',
      whatsIncluded: 'Ce este inclus',
      freeWifi: 'WiFi gratuit de mare viteză',
      breakfastOptions: 'Opțiuni de mic dejun',
      freeCancellation: 'Anulare gratuită',
      bestPrice: 'Garanția celui mai bun preț',
      checkAvailabilityPrices: 'Verifică disponibilitatea și prețurile',
      loading: 'Se încarcă...',
      changeDates: 'Schimbă datele',
      secureByBeds24: 'Rezervare securizată prin Beds24',
      pricesIncludeTaxes: 'Toate prețurile includ taxe',
      yourStay: 'Sejurul dvs.',
      night: 'noapte',
      nights: 'nopți',
      startingFrom: 'De la',
      priceLabel: 'Preț',
      securePayment: 'Plată securizată',
      instantConfirmation: 'Confirmare instantanee',
      loadingRooms: 'Se încarcă camerele disponibile...',
      pleaseWait: 'Vă rugăm așteptați'
    },
    // Flash Deal
    flashDeal: {
      extraDiscount: 'Extra 5% REDUCERE — Rezervați în următoarele'
    },
    social: {
      title: 'Urmăriți călătoria noastră',
      subtitle: 'Conectați-vă cu noi',
      description: 'Rămâneți la curent cu cele mai recente noutăți de la Hotelul Uma Premium.',
      instagramDesc: 'Fotografii frumoase din hotelul nostru.',
      facebookDesc: 'Noutăți, recenzii, oferte speciale.',
      tiktokDesc: 'Videoclipuri distractive și tururi virtuale.',
      followInstagram: 'Urmărește pe Instagram',
      followFacebook: 'Like pe Facebook',
      followTiktok: 'Urmărește pe TikTok',
      shareExperience: 'Împărtășiți experiența dvs.:'
    },
    virtualTour: {
      title: 'Tur Virtual 360°',
      subtitle: 'Experiență imersivă',
      description: 'Explorați fiecare colț al Hotelului Uma Premium din confortul casei.',
      exterior: 'Exteriorul hotelului',
      exteriorDesc: 'Explorați clădirea noastră frumoasă',
      pool: 'Piscină pe acoperiș',
      poolDesc: 'Experimentați piscina noastră uimitoare',
      restaurant: 'Restaurant',
      restaurantDesc: 'Descoperiți zona noastră elegantă de dining',
      reception: 'Recepție și lobby',
      receptionDesc: 'Bine ați venit la recepția noastră modernă',
      rooms: 'Camere pentru oaspeți',
      roomsDesc: 'Vizitați camerele noastre confortabile',
      apartments: 'Apartamente',
      apartmentsDesc: 'Explorați apartamentele noastre spațioase',
      loading: 'Se încarcă vizualizarea 360°...',
      dragToExplore: 'Trageți pentru a explora • Derulați pentru zoom',
      openFullTour: 'Deschide turul complet 360° în Google Maps'
    },
    specialOffer: {
      title: 'Ofertă specială',
      discount: '10% REDUCERE',
      description: 'Rezervați direct și economisiți! Primiți 10% reducere la toate camerele.',
      bookDirect: 'Rezervă direct',
      limitedTime: 'Ofertă limitată'
    },
    bestPrice: {
      badge: 'Garanția celui mai bun preț',
      title: 'Garanția celui mai bun preț',
      description: 'Rezervați direct la noi și obțineți cel mai bun preț disponibil.'
    },
    whyBookDirect: {
      exclusive: 'Beneficii exclusive',
      title: 'De ce să rezervați direct?',
      subtitle: 'Bucurați-vă de beneficii exclusive când rezervați pe site-ul nostru',
      bestPrice: 'Garanția celui mai bun preț',
      bestPriceDesc: 'Garantăm cel mai mic preț. Găsiți mai ieftin? Egalăm!',
      discount: '10% reducere',
      discountDesc: 'Economisiți instant 10% la toate tipurile de camere.',
      freeCancellation: 'Anulare flexibilă',
      freeCancellationDesc: 'Planurile se schimbă. Anulare gratuită cu 24h înainte.',
      directSupport: 'Suport 24/7',
      directSupportDesc: 'Întrebări? Echipa noastră este disponibilă non-stop.',
      bookNow: 'Rezervați direct și economisiți'
    }
  }
};

export default translations;
